/**
 * AUTO-GENERATED from backend/data/phone_models.csv — do not edit by hand.
 * Regenerate: python backend/scripts/generate_phone_catalog_ts.py
 */

export interface BrandCatalog {
  popular: string[]
  all: string[]
  storages: string[]
}

export const PHONE_CATALOG: Record<string, BrandCatalog> = {
  Apple: {
    popular: ['iPhone 16e', 'iPhone 17', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone Air'],
    all: [
      'iPhone 16e',
      'iPhone 17',
      'iPhone 17 Pro',
      'iPhone 17 Pro Max',
      'iPhone Air',
      'iPhone 16',
      'iPhone 16 Plus',
      'iPhone 16 Pro',
      'iPhone 16 Pro Max',
      'iPhone SE (2024)',
      'iPhone 15',
      'iPhone 15 Plus',
      'iPhone 15 Pro',
      'iPhone 15 Pro Max',
      'iPhone 14',
      'iPhone 14 Plus',
      'iPhone 14 Pro',
      'iPhone 14 Pro Max',
      'iPhone SE3 (2022)',
      'iPhone 13',
      'iPhone 13 mini',
      'iPhone 13 Pro',
      'iPhone 13 Pro Max',
      'iPhone 12',
      'iPhone 12 mini',
      'iPhone 12 Pro',
      'iPhone 12 Pro Max',
      'iPhone SE2 (2020)',
      'iPhone 11',
      'iPhone 11 Pro',
      'iPhone 11 Pro Max',
      'iPhone XR',
      'iPhone XS',
      'iPhone XS Max',
      'iPhone 8',
      'iPhone 8 Plus',
      'iPhone X',
      'iPhone 7',
      'iPhone 7 Plus',
      'iPhone SE',
      'iPhone 6s',
      'iPhone 6s Plus',
      'iPhone 6',
      'iPhone 6 Plus',
      'iPhone 5c',
      'iPhone 5s',
      'iPhone 5',
      'iPhone 4 CDMA',
      'iPhone 4s',
      'iPhone 4',
      'iPhone 3GS',
      'iPhone 3G',
      'iPhone',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Samsung: {
    popular: ['Z4', 'Z2', 'Z3 Corporate', 'Z3', 'Xcover 550'],
    all: [
      'Z4',
      'Z2',
      'Z3 Corporate',
      'Z3',
      'Xcover 550',
      'Z1',
      'Z',
      'Metro 312',
      'Guru Music 2',
      'S5611',
      'C3590',
      'Gravity Q T289',
      'Ch@t 333',
      'Rex 90 S5292',
      'Rex 80 S5222R',
      'Rex 70 S3802',
      'Rex 60 C3312R',
      'Metro E2202',
      'E1282T',
      'E1207T',
      'Star Deluxe Duos S5292',
      'A997 Rugby III',
      'Comment 2 R390C',
      'Champ Neo Duos C3262',
      'Manhattan E3300',
      'E2262',
      'Array M390',
      'U485 Intensity III',
      'E2252',
      'E1260B',
      'I9500 Fraser',
      'Focus 2 I667',
      'C3782 Evan',
      'C3780',
      'E2350B',
      'U380 Brightside',
      'Rugby Smart I847',
      'Star 3 s5220',
      'Star 3 Duos S5222',
      'M370',
      'Exhilarate i577',
      'C3312 Duos',
      'W999',
      'R680 Repp',
      'I110 Illusion',
      'E2600',
      'R730 Transfix',
      'i927 Captivate Glide',
      'I405 Stratosphere',
      'Exhibit II 4G T679',
      'DoubleTime I857',
      'C3520',
      'C3350',
      'C3330 Champ 2',
      'M930 Transform Ultra',
      'Focus S I937',
      'Focus Flash I677',
      'Ch@t 527',
      'S8600 Wave 3',
      'S5610',
      'S3770',
      'Gravity TXT T379',
      'E1232B',
      'E1230',
      'Convoy 2',
      'R640 Character',
      'R380 Freeform III',
      'E1195',
      'E1190',
      'Trender',
      'R720 Admire',
      'Gravity SMART',
      'Exhibit 4G',
      'Conquer 4G',
      'C414',
      'R260 Chrono',
      'Dart T499',
      'Ch@t 222',
      'Ch@t 220',
      'M580 Replenish',
      'E2232',
      'E1182',
      'C6712 Star II DUOS',
      'C3560',
      'C3322',
      'S3850 Corby II',
      'M260 Factor',
      'E2230',
      'S5780 Wave 578',
      'E3210',
      'E2652W Champ Duos',
      'E2652 Champ Duos',
      'Ch@t 350',
      'S5260 Star II',
      'R710 Suede',
      'I997 Infuse 4G',
      'I100 Gem',
      'E2330',
      'Droid Charge I510',
      'C3630',
      'U750 Zeal',
      'R580 Profile',
      'R570 Messenger III',
      'M210S Wave2',
      'E2530',
      'Continuum I400',
      'Ch@t 335',
      'C3750',
      'C3530',
      'A817 Solstice II',
      'A667 Evergreen',
      'S8530 Wave II',
      'S5750 Wave575',
      'R360 Freeform II',
      'Mesmerize i500',
      'M920 Transform',
      'I8700 Omnia 7',
      'Focus',
      'E1252',
      'Ch@t 322',
      'Xcover 271',
      'T249',
      'R900 Craft',
      'U360 Gusto',
      'S7230E Wave 723',
      'S5530',
      'E2152',
      'A927 Flight II',
      'A220 F Nori',
      'U460 Intensity II',
      'U320 Haven',
      'T369',
      'Intercept',
      'i220 Code',
      'Vibrant',
      'T669 Gravity T',
      'T479 Gravity 3',
      'S5330 Wave533',
      'S5250 Wave525',
      'i897 Captivate',
      'Fascinate',
      'Epic 4G',
      'B7722',
      'B7350 Omnia PRO 4',
      'B6520 Omnia PRO 5',
      'Acclaim',
      ':) Smiley',
      'R360 Messenger Touch',
      'M350 Seek',
      'C5010 Squash',
      'C3300K Champ',
      'A847 Rugby II',
      'W960 AMOLED 3D',
      'S3370',
      'Metro TV',
      'M570 Restore',
      'i225 Exec',
      'E1170',
      'Corby TV F339',
      'W9705',
      'S3650W Corby',
      'A697 Sunburst',
      'A687 Strive',
      'S8500 Wave',
      'S5620 Monte',
      'R860 Caliber',
      'M3710 Corby Beat',
      'E2550 Monte Slider',
      'E2370 Xcover',
      'E1150',
      'C3200 Monte Bar',
      'B3410W Ch@t',
      'S5550 Shark 2',
      'S5350 Shark',
      'S3550 Shark 3',
      'M2520 Beat Techno',
      'C6112',
      'S7070 Diva',
      'S5500 Eco',
      'S5150 Diva folder',
      'M5650 Lindy',
      'C3510 Genoa',
      'A886 Forever',
      'T139',
      'S5630C',
      'M715 T*OMNIA II',
      'C5130',
      'B5722',
      'T939 Behold 2',
      'T401G',
      'S5560 Marvel',
      'S5510',
      'M3310L',
      'M3310',
      'E1130B',
      'B7620 Giorgio Armani',
      'B3410',
      'A897 Mythic',
      'A797 Flight',
      'W880 AMOLED 12M',
      'Vodafone 360 M1',
      'Vodafone 360 H1',
      'T659 Scarlet',
      'S7550 Blue Earth',
      'S5230W Star WiFi',
      'R520 Trill',
      'E2130',
      'E1390',
      'E1160',
      'E1085T',
      'E1080T',
      'B7330 OmniaPRO',
      'B5310 CorbyPRO',
      'B3210 CorbyTXT',
      'S5233T',
      'S3650 Corby',
      'S3100',
      'R351 Freeform',
      'M900 Moment',
      'I6220 Star TV',
      'E2120',
      'C3212',
      'B3310',
      'U450 Intensity',
      'U450 DoubleTake',
      'T559 Comeback',
      'T469 Gravity 2',
      'A887 Solstice',
      'W850',
      'T746 Impact',
      'S8000 Jet',
      'S6700',
      'S5600v Blade',
      'M8910 Pixon12',
      'M2710 Beat Twist',
      'M2510',
      'M2310',
      'I8000 Omnia II',
      'E1107 Crest Solar',
      'C5510',
      'B7610 OmniaPRO',
      'B7300 OmniaLITE',
      'T349',
      'S5200',
      'i637 Jack',
      'C3060R',
      'B7320 OmniaPRO',
      'A177',
      'A167',
      'U960 Rogue',
      'SCH-W699',
      'P250',
      'E1360',
      'E1210',
      'A657',
      'S5600 Preston',
      'S5230 Star',
      'Propel Pro',
      'M850 Instinct HD',
      'i350 Intrepid',
      'C5220',
      'B2100 Xplorer',
      'A877 Impression',
      'A257 Magnet',
      'T929 Memoir',
      'S8300 UltraTOUCH',
      'S7350 Ultra s',
      'S7220 Ultra b',
      'S5050',
      'S3500',
      'S3310',
      'S3110',
      'M7600 Beat DJ',
      'M6710 Beat DISC',
      'i8910 Omnia HD',
      'i7410',
      'F480i',
      'E2210B',
      'E1310',
      'E1120',
      'E1100',
      'E1070',
      'C5212',
      'C3050 Stratus',
      'C3010',
      'B5702',
      'J165',
      'E2100B',
      'E1125',
      'C3110',
      'S9402 Ego',
      'I6210',
      'E1410',
      'B520',
      'U810 Renown',
      'T919 Behold',
      'T459 Gravity',
      'S3030 Tobi',
      'i770 Saga',
      'E2510',
      'E1110',
      'A867 Eternity',
      'A777',
      'T109',
      'S3600',
      'i907 Epix',
      'i7110',
      'F275',
      'F270 Beat',
      'C6625',
      'C6620',
      'A767 Propel',
      'A637',
      'P270',
      'M8800 Pixon',
      'M7500 Emporio Armani',
      'M3510 Beat b',
      'M3200 Beat s',
      'M200',
      'C510',
      'B510',
      'B2700',
      'B210',
      'B130',
      'A837 Rugby',
      'A237',
      'F268',
      'E215',
      'E200 ECO',
      'D980',
      'S7330',
      'M150',
      'i8510 INNOV8',
      'i740',
      'B320',
      'T339',
      'T229',
      'M140',
      'M130',
      'L700',
      'J800 Luxe',
      'Impact sf',
      'Impact b',
      'Impact',
      'i900 Omnia',
      'B300',
      'U800 Soul b',
      'M310',
      'L810v Steel',
      'P220',
      'M620',
      'L870',
      'D780',
      'B200',
      'B110',
      'A827 Access',
      'G400 Soul',
      'F110',
      'U900 Soul',
      'P960',
      'L770',
      'J700',
      'J630',
      'J210',
      'J150',
      'i640',
      'i200',
      'G810',
      'F480',
      'F400',
      'E251',
      'B500',
      'A746',
      'T819',
      'M110',
      'L320',
      'L310',
      'L170',
      'J400',
      'F490',
      'B100',
      'SPH-i325 Ace',
      'P180',
      'T739 Katalyst',
      'T439',
      'T639',
      'T539 Beat',
      'Serenata',
      'M610',
      'J750',
      'J610',
      'i617 BlackJack II',
      'i560',
      'G800',
      'D880 Duos',
      'C500',
      'A737',
      'A127',
      'T429',
      'i780',
      'Armani',
      'A711',
      'A517',
      'T729 Blast',
      'J200',
      'i550',
      'i450',
      'F330',
      'F250',
      'E230',
      'E210',
      'ZV60',
      'Z170',
      'S730i',
      'S720i',
      'P260',
      'L760',
      'L600',
      'G600',
      'C450',
      'C180',
      'A437',
      'A117',
      'T409',
      'i620',
      'F210',
      'F200',
      'E950',
      'A727',
      'A717',
      'M300',
      'C170',
      'Z240',
      'J600',
      'i400',
      'C520',
      'U700',
      'U600',
      'U300',
      'U100',
      'P110',
      'i710',
      'i520',
      'F700',
      'F520',
      'F510',
      'E840',
      'E830',
      'E740',
      'E590',
      'E200',
      'C260',
      'C250',
      'C160',
      'E790',
      'C140',
      'P940',
      'P930',
      'i607 BlackJack',
      'i600',
      'F500',
      'F300',
      'E690',
      'E490',
      'E480',
      'Z650i',
      'X540',
      'X530',
      'X520',
      'X510',
      'E898',
      'E890',
      'E570',
      'E420',
      'E390',
      'E250',
      'C300',
      'Z230',
      'X830',
      'P310',
      'C400',
      'Z720',
      'Z620',
      'Z370',
      'ZV40',
      'S501i',
      'S401i',
      'P200',
      'E380',
      'X500',
      'D900',
      'D840',
      'D830',
      'C240',
      'X820',
      'X210',
      'T509',
      'E500',
      'C130',
      'ZV50',
      'Z550',
      'Z400',
      'i310',
      'E900',
      'E370',
      'D870',
      'D780 flip',
      'Z710',
      'Z600',
      'Z560',
      'Z520',
      'Z350',
      'Z330',
      'Z310',
      'Z150',
      'X300',
      'S400i',
      'P910',
      'P900',
      'i320',
      'D520',
      'D300',
      'Serene',
      'D550',
      'P730',
      'P710',
      'i500',
      'E810',
      'E800',
      'i700',
      'Galaxy Z Flip8',
      'Galaxy M47',
      'Galaxy A27',
      'Galaxy A57',
      'Galaxy A37',
      'Galaxy F70e',
      'Galaxy A07',
      'Galaxy M17',
      'Galaxy M07',
      'Galaxy F07',
      'Galaxy S25 FE',
      'Galaxy F17',
      'Galaxy A17 4G',
      'Galaxy A17',
      'Galaxy A07 4G',
      'Galaxy Z Fold7',
      'Galaxy Z Flip7 FE',
      'Galaxy Z Flip7',
      'Galaxy F36',
      'Galaxy M36',
      'Galaxy S25 Edge',
      'Galaxy F56',
      'Galaxy XCover7 Pro',
      'Galaxy M56',
      'Galaxy F16',
      'Galaxy A56',
      'Galaxy A36',
      'Galaxy A26',
      'Galaxy M16',
      'Galaxy M06',
      'Galaxy F06 5G',
      'Galaxy A06 5G',
      'Galaxy S25+',
      'Galaxy S25 Ultra',
      'Galaxy S25',
      'Galaxy Z Fold Special',
      'Galaxy A16 5G',
      'Galaxy A16',
      'Galaxy S24 FE',
      'Galaxy M55s',
      'Galaxy M05',
      'Galaxy F05',
      'Galaxy F14 4G',
      'Galaxy A06',
      'Galaxy Z Fold6',
      'Galaxy Z Flip6',
      'Galaxy M35',
      'Galaxy F55',
      'Galaxy C55',
      'Galaxy M55',
      'Galaxy M15',
      'Galaxy M14 4G',
      'Galaxy F15',
      'Galaxy A55',
      'Galaxy A35',
      'Galaxy XCover7',
      'Galaxy S24+',
      'Galaxy S24 Ultra',
      'Galaxy S24',
      'Galaxy A25',
      'Galaxy A15 5G',
      'Galaxy A15',
      'Galaxy S23 FE',
      'Galaxy A05s',
      'Galaxy A05',
      'Galaxy F34',
      'Galaxy Z Fold5',
      'Galaxy Z Flip5',
      'Galaxy M34 5G',
      'Galaxy F54',
      'Galaxy A24 4G',
      'Galaxy M54',
      'Galaxy M14',
      'Galaxy F14',
      'Galaxy A54',
      'Galaxy A34',
      'Galaxy S23+',
      'Galaxy S23 Ultra',
      'Galaxy S23',
      'Galaxy A14',
      'Galaxy F04',
      'Galaxy A14 5G',
      'Galaxy M04',
      'Galaxy A04e',
      'Galaxy Z Fold4',
      'Galaxy Z Flip4',
      'Galaxy A23 5G',
      'Galaxy A04s',
      'Galaxy A04',
      'Galaxy M13 5G',
      'Galaxy M13 (India)',
      'Galaxy XCover6 Pro',
      'Galaxy F13',
      'Galaxy A13 (SM-A137)',
      'Galaxy M13',
      'Galaxy S20 FE 2022',
      'Galaxy M53',
      'Galaxy M33',
      'Galaxy M23',
      'Galaxy F23',
      'Galaxy A73 5G',
      'Galaxy A53 5G',
      'Galaxy A33 5G',
      'Galaxy A23',
      'Galaxy A13',
      'Galaxy S22+ 5G',
      'Galaxy S22 Ultra 5G',
      'Galaxy S22 5G',
      'Galaxy S21 FE 5G',
      'Galaxy A13 5G',
      'Galaxy A03 Core',
      'Galaxy A03',
      'Galaxy M52 5G',
      'Galaxy M22',
      'Galaxy F42 5G',
      'Galaxy Z Fold3 5G',
      'Galaxy Z Flip3 5G',
      'Galaxy M32 5G',
      'Galaxy A52s 5G',
      'Galaxy A12 Nacho',
      'Galaxy A12 (India)',
      'Galaxy A03s',
      'Galaxy M21 2021',
      'Galaxy F22',
      'Galaxy M32',
      'Galaxy A22 5G',
      'Galaxy A22',
      'Galaxy F52 5G',
      'Galaxy Quantum 2',
      'Galaxy M42 5G',
      'Galaxy M12',
      'Galaxy F12',
      'Galaxy F02s',
      'Galaxy XCover 5',
      'Galaxy A72',
      'Galaxy A52 5G',
      'Galaxy A52',
      'Galaxy M62',
      'Galaxy M12 (India)',
      'Galaxy M02',
      'Galaxy F62',
      'Galaxy A32',
      'Galaxy S21+ 5G',
      'Galaxy S21 Ultra 5G',
      'Galaxy S21 5G',
      'Galaxy M02s',
      'Galaxy A32 5G',
      'Galaxy A02',
      'Galaxy M21s',
      'Galaxy A12',
      'Galaxy A02s',
      'Galaxy M31 Prime',
      'Galaxy F41',
      'Galaxy S20 FE 5G',
      'Galaxy S20 FE',
      'Galaxy A42 5G',
      'Galaxy Z Fold2 5G',
      'Galaxy Note20 Ultra 5G',
      'Galaxy Note20 Ultra',
      'Galaxy Note20 5G',
      'Galaxy Note20',
      'Galaxy M51',
      'Galaxy A51 5G UW',
      'Galaxy Z Flip 5G',
      'Galaxy M31s',
      'Galaxy M01s',
      'Galaxy M01 Core',
      'Galaxy A71 5G UW',
      'Galaxy A01 Core',
      'Galaxy M01',
      'Galaxy S20 5G UW',
      'Galaxy A21s',
      'Galaxy A Quantum',
      'Galaxy J2 Core (2020)',
      'Galaxy A71 5G',
      'Galaxy A51 5G',
      'Galaxy A21',
      'Galaxy M21',
      'Galaxy M11',
      'Galaxy A41',
      'Galaxy A31',
      'Galaxy A11',
      'Galaxy Z Flip',
      'Galaxy S20+ 5G',
      'Galaxy S20+',
      'Galaxy S20 Ultra 5G',
      'Galaxy S20 Ultra',
      'Galaxy S20 5G',
      'Galaxy S20',
      'Galaxy M31',
      'Galaxy XCover Pro',
      'Galaxy S10 Lite',
      'Galaxy Note10 Lite',
      'Galaxy A71',
      'Galaxy A51',
      'Galaxy A01',
      'Galaxy XCover FieldPro',
      'Galaxy M30s',
      'Galaxy M10s',
      'Galaxy A90 5G',
      'Galaxy A70s',
      'Galaxy A20s',
      'Galaxy Note10+ 5G',
      'Galaxy Note10+',
      'Galaxy Note10 5G',
      'Galaxy Note10',
      'Galaxy A50s',
      'Galaxy A30s',
      'Galaxy A10s',
      'Galaxy A10e',
      'Galaxy XCover 4s',
      'Galaxy M40',
      'Galaxy A80',
      'Galaxy A60',
      'Galaxy A20e',
      'Galaxy A2 Core',
      'Galaxy A70',
      'Galaxy A40',
      'Galaxy A20',
      'Galaxy S10e',
      'Galaxy S10+',
      'Galaxy S10 5G',
      'Galaxy S10',
      'Galaxy M30',
      'Galaxy Fold 5G',
      'Galaxy Fold',
      'Galaxy A50',
      'Galaxy A30',
      'Galaxy A10',
      'Galaxy M20',
      'Galaxy M10',
      'Galaxy A8s',
      'Galaxy J4 Core',
      'Galaxy A9 (2018)',
      'Galaxy A6s (2018)',
      'Galaxy J6+',
      'Galaxy J4+',
      'Galaxy A7 (2018)',
      'Galaxy Note9',
      'Galaxy J2 Core',
      'Galaxy On6',
      'Galaxy J7 (2018)',
      'Galaxy J3 (2018)',
      'Galaxy A8 Star (A9 Star)',
      'Galaxy S Light Luxury',
      'Galaxy J8',
      'Galaxy J6',
      'Galaxy J4',
      'Galaxy A6+ (2018)',
      'Galaxy A6 (2018)',
      'Galaxy J7 Duo',
      'Galaxy J7 Prime 2',
      'Galaxy S9+',
      'Galaxy S9',
      'Galaxy J2 Pro (2018)',
      'Galaxy A8+ (2018)',
      'Galaxy A8 (2018)',
      'Galaxy J2 (2017)',
      'Galaxy C7 (2017)',
      'Galaxy S8 Active',
      'Galaxy Note8',
      'Galaxy Note FE',
      'Galaxy J7 Nxt',
      'Galaxy Folder2',
      'Galaxy J7 Pro',
      'Galaxy J7 Max',
      'Galaxy J7 (2017)',
      'Galaxy J5 (2017)',
      'Galaxy J3 (2017)',
      'Galaxy XCover 4',
      'Galaxy S8+',
      'Galaxy S8',
      'Galaxy J7 V',
      'Galaxy C5 Pro',
      'Galaxy J3 Emerge',
      'Galaxy C7 Pro',
      'Galaxy A7 (2017)',
      'Galaxy A5 (2017)',
      'Galaxy A3 (2017)',
      'Galaxy J1 mini prime',
      'Galaxy J2 Prime',
      'Galaxy Grand Prime Plus',
      'Galaxy C9 Pro',
      'Galaxy On8',
      'Galaxy On7 (2016)',
      'Galaxy J7 Prime',
      'Galaxy J5 Prime',
      'Galaxy A8 (2016)',
      'Galaxy Note7 (USA)',
      'Galaxy Note7',
      'Galaxy On7 Pro',
      'Galaxy On5 Pro',
      'Galaxy J2 Pro (2016)',
      'Galaxy J2 (2016)',
      'Galaxy J Max',
      'Galaxy S7 active',
      'Galaxy J3 Pro',
      'Galaxy C7',
      'Galaxy C5',
      'Galaxy Xcover 3 G389F',
      'Galaxy Express Prime',
      'Galaxy J7 (2016)',
      'Galaxy J5 (2016)',
      'Galaxy J3 (2016)',
      'Galaxy A9 Pro (2016)',
      'Galaxy S7 edge (USA)',
      'Galaxy S7 edge',
      'Galaxy S7 (USA)',
      'Galaxy S7',
      'Galaxy J1 Nxt',
      'Galaxy J1 (2016)',
      'Galaxy A9 (2016)',
      'Galaxy A7 (2016)',
      'Galaxy A5 (2016)',
      'Galaxy A3 (2016)',
      'Galaxy On7',
      'Galaxy On5',
      'Galaxy J2',
      'Galaxy S6 edge+ Duos',
      'Galaxy S6 edge+ (USA)',
      'Galaxy S6 edge+',
      'Galaxy S5 Neo',
      'Galaxy Note5 Duos',
      'Galaxy Note5 (USA)',
      'Galaxy Note5',
      'Galaxy J1 Ace',
      'Galaxy A8 Duos',
      'Galaxy V Plus',
      'Galaxy Folder',
      'Galaxy A8',
      'Galaxy S6 Duos',
      'Galaxy S6 active',
      'Galaxy S4 mini I9195I',
      'Galaxy J7',
      'Galaxy J5',
      'Galaxy XCover 3',
      'Galaxy S6 edge (USA)',
      'Galaxy S6 edge',
      'Galaxy S6 (USA)',
      'Galaxy S6',
      'Galaxy J1 4G',
      'Galaxy J1',
      'Galaxy Grand Max',
      'Galaxy E7',
      'Galaxy E5',
      'Galaxy A7 Duos',
      'Galaxy A7',
      'Galaxy Core Prime',
      'Galaxy Core LTE G386W',
      'Galaxy S5 Plus',
      'Galaxy Note 4 Duos',
      'Galaxy Grand Prime Duos TV',
      'Galaxy A5 Duos',
      'Galaxy A5',
      'Galaxy A3 Duos',
      'Galaxy A3',
      'Galaxy V',
      'Galaxy Pocket 2',
      'Galaxy Note Edge',
      'Galaxy Note 4',
      'Galaxy Mega 2',
      'Galaxy Grand Prime',
      'Galaxy Ace Style LTE G357',
      'Galaxy S5 mini Duos',
      'Galaxy S5 LTE-A G901F',
      'Galaxy S Duos 3',
      'Galaxy Alpha (S801)',
      'Galaxy Alpha',
      'Galaxy Star 2 Plus',
      'Galaxy Avant',
      'Galaxy Ace NXT',
      'I9301I Galaxy S3 Neo',
      'Galaxy Young 2',
      'Galaxy W',
      'Galaxy Star 2',
      'Galaxy S5 Sport',
      'Galaxy S5 mini',
      'Galaxy S5 LTE-A G906S',
      'Galaxy S5 Duos',
      'Galaxy Core Lite LTE',
      'Galaxy Core II',
      'Galaxy Ace 4 LTE G313',
      'Galaxy Ace 4',
      'Galaxy S5 Active',
      'I9300I Galaxy S3 Neo',
      'Galaxy K zoom',
      'Galaxy Beam2',
      'Galaxy Ace Style',
      'ATIV SE',
      'I8200 Galaxy S III mini VE',
      'Galaxy S5 (octa-core)',
      'G3812B Galaxy S3 Slim',
      'Galaxy Star Trios S5283',
      'Galaxy S5 (USA)',
      'Galaxy S5',
      'Galaxy Core LTE',
      'Galaxy Note 3 Neo Duos',
      'Galaxy Note 3 Neo',
      'Galaxy Grand Neo',
      'Galaxy Camera 2 GC200',
      'Galaxy Win Pro G3812',
      'Galaxy S4 Active LTE-A',
      'Galaxy J',
      'Galaxy Core Advance',
      'Galaxy S Duos 2 S7582',
      'Galaxy Grand 2',
      'I9230 Galaxy Golden',
      'Galaxy Star Pro S7260',
      'Galaxy Round G910S',
      'Galaxy Light',
      'Galaxy Fresh S7390',
      'Galaxy Fame Lite S6790',
      'Galaxy Fame Lite Duos S6792L',
      'Galaxy Express 2',
      'Galaxy Core Plus',
      'Galaxy Note 3',
      'Galaxy Prevail 2',
      'I9295 Galaxy S4 Active',
      'Galaxy S4 zoom',
      'Galaxy Ace 3',
      'ATIV S Neo',
      'I9190 Galaxy S4 mini',
      'Galaxy S4 CDMA',
      'Galaxy Exhibit T599',
      'Galaxy Core I8260',
      'Galaxy Win I8550',
      'Galaxy Trend II Duos S7572',
      'Galaxy Star S5280',
      'Galaxy Pocket Neo S5310',
      'Galaxy Mega 6.3 I9200',
      'Galaxy Mega 5.8 I9150',
      'I9505 Galaxy S4',
      'I9502 Galaxy S4',
      'I9500 Galaxy S4',
      'Galaxy Y Plus S5303',
      'Galaxy Young S6310',
      'Galaxy Fame S6810',
      'S7710 Galaxy Xcover 2',
      'I9105 Galaxy S II Plus',
      'Galaxy Pop SHV-E220',
      'Galaxy Express I8730',
      'Ativ Odyssey I930',
      'Galaxy Grand I9082',
      'Galaxy Grand I9080',
      'Galaxy Stratosphere II I415',
      'Galaxy Premier I9260',
      'Galaxy Discover S730M',
      'Galaxy Axiom R830',
      'I8190 Galaxy S III mini',
      'Galaxy Rugby Pro I547',
      'Galaxy Music S6010',
      'Galaxy Music Duos S6012',
      'Galaxy Express I437',
      'Ativ Tab P8510',
      'I9305 Galaxy S III',
      'Galaxy Victory 4G LTE L300',
      'Galaxy S Relay 4G T699',
      'Galaxy Stellar 4G I200',
      'Galaxy S Lightray 4G R940',
      'Galaxy Rush M830',
      'Galaxy Pocket Duos S5302',
      'Galaxy Note II N7100',
      'Galaxy Camera GC100',
      'Ativ S I8750',
      'Galaxy S Duos S7562',
      'Galaxy Chat B5330',
      'Galaxy S III T999',
      'Galaxy S III I747',
      'Galaxy S III CDMA',
      'Galaxy I8250',
      'Omnia M S7530',
      'I9300 Galaxy S III',
      'Galaxy Proclaim S720C',
      'Galaxy Appeal I827',
      'Galaxy Ace Duos S6802',
      'Galaxy Ace Advance S6800',
      'Galaxy Player 70 Plus',
      'Galaxy Note T879',
      'I8530 Galaxy Beam',
      'Galaxy Pop Plus S5570i',
      'Galaxy Pocket S5300',
      'Galaxy mini 2 S6500',
      'Galaxy Ace Duos I589',
      'Galaxy Ace 2 I8160',
      'I9070 Galaxy S Advance',
      'Galaxy S II Skyrocket HD I757',
      'Galaxy S Blaze 4G T769',
      'Galaxy Note I717',
      'Galaxy Nexus LTE L700',
      'Galaxy Nexus I9250M',
      'Galaxy M Style M340S',
      'Galaxy Attain 4G',
      'Galaxy Ace Plus S7500',
      'I929 Galaxy S II Duos',
      'Galaxy Y Pro Duos B5512',
      'Galaxy Y Duos S6102',
      'Galaxy S II X T989D',
      'Galaxy S II Skyrocket i727',
      'Galaxy Nexus I9250',
      'Galaxy Nexus i515',
      'Omnia W I8350',
      'Galaxy S II HD LTE',
      'Galaxy Note N7000',
      'Wave Y S5380',
      'Wave M S7250',
      'S5690 Galaxy Xcover',
      'Galaxy Y S5360',
      'Galaxy Y Pro B5510',
      'Galaxy W I8150',
      'Galaxy S II T989',
      'Galaxy S II LTE I9210',
      'Galaxy S II I777',
      'Galaxy S II Epic 4G Touch',
      'Galaxy Reverb M950',
      'Galaxy Q T589R',
      'Galaxy M Pro B7800',
      'Galaxy S II 4G I9100M',
      'I9103 Galaxy R',
      'I9001 Galaxy S Plus',
      'Galaxy Prevail',
      'M220L Galaxy Neo',
      'Google Nexus S I9023',
      'Google Nexus S I9020A',
      'Google Nexus S 4G',
      'Galaxy Pro B7510',
      'Galaxy Pop i559',
      'I9100 Galaxy S II',
      'I9003 Galaxy SL',
      'Galaxy S WiFi 5.0',
      'R910 Galaxy Indulge',
      'Galaxy S 4G T959',
      'Galaxy Mini S5570',
      'Galaxy Gio S5660',
      'Galaxy Fit S5670',
      'Galaxy Ace S5830',
      'Google Nexus S',
      'I9010 Galaxy S Giorgio Armani',
      'M190S Galaxy S Hoppin',
      'M130K Galaxy K',
      'Galaxy 551',
      'I909 Galaxy S',
      'M130L Galaxy U',
      'M110S Galaxy S',
      'I5801 Galaxy Apollo',
      'I5800 Galaxy 3',
      'I5500 Galaxy 5',
      'Galaxy A',
      'I9000 Galaxy S',
      'I6500U Galaxy',
      'I8520 Galaxy Beam',
      'I5700 Galaxy Spica',
      'I7500 Galaxy',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Google: {
    popular: ['Pixel 9a', 'Pixel 9 Pro XL', 'Pixel 9 Pro Fold', 'Pixel 9 Pro', 'Pixel 9'],
    all: [
      'Pixel 9a',
      'Pixel 9 Pro XL',
      'Pixel 9 Pro Fold',
      'Pixel 9 Pro',
      'Pixel 9',
      'Pixel 8a',
      'Pixel 8 Pro',
      'Pixel 8',
      'Pixel Fold',
      'Pixel 7a',
      'Pixel 7 Pro',
      'Pixel 7',
      'Pixel 6a',
      'Pixel 6 Pro',
      'Pixel 6',
      'Pixel 5a 5G',
      'Pixel 5',
      'Pixel 4a 5G',
      'Pixel 4a',
      'Pixel 4 XL',
      'Pixel 4',
      'Pixel 3a XL',
      'Pixel 3a',
      'Pixel 3 XL',
      'Pixel 3',
      'Pixel 2 XL',
      'Pixel 2',
      'Pixel XL',
      'Pixel',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Xiaomi: {
    popular: ['Redmi Pro 2', 'Redmi 20X', 'Redmi 11A', 'Redmi 11', 'Redmi 10 Prime+ 5G'],
    all: [
      'Redmi Pro 2',
      'Redmi 20X',
      'Redmi 11A',
      'Redmi 11',
      'Redmi 10 Prime+ 5G',
      'Poco X4 NFC',
      'Mi Note Plus',
      'Mi Max 4 Pro',
      'Mi Max 4',
      'Mi 9X',
      'Mi 6c',
      'Mi 6 Plus',
      'Mi 2A',
      'Mi 10 Lite Zoom',
      '12 Lite NE',
      'Redmi Note 17 Pro (China)',
      'Redmi Note 17 (China)',
      'Redmi K90 Ultra',
      'Redmi 17C',
      '17T Pro',
      '17T',
      '17 Max',
      'Redmi R70m',
      'Redmi R70',
      'Redmi Note 15 Special',
      'Redmi K90 Max',
      'Redmi A7 Pro',
      'Redmi A7',
      'Poco M8s',
      'Poco C81x',
      'Poco C81 Pro',
      'Poco C81',
      'Redmi 15a',
      'Poco X8 Pro Max',
      'Poco X8 Pro',
      'Poco C85x',
      'Redmi A7 Pro 4G',
      '17 Ultra',
      'Redmi Turbo 5 Max',
      'Redmi Turbo 5',
      'Poco M8 Pro',
      'Poco M8',
      'Redmi Note 15 Pro+',
      'Redmi Note 15 Pro 4G',
      'Redmi Note 15 Pro',
      'Redmi Note 15 4G',
      'Redmi Note 15',
      'Poco C85',
      '17 Ultra (China)',
      'Poco F8 Ultra',
      'Poco F8 Pro',
      'Black Shark GS3 Ultra',
      'Black Shark GS3',
      'Redmi K90 Pro Max',
      'Redmi K90',
      'Redmi 15C',
      'Poco C85 4G',
      '17 Pro Max',
      '17 Pro',
      '17',
      '15T Pro',
      '15T',
      'Redmi Note 15 Pro+ (China)',
      'Redmi Note 15 Pro (China)',
      'Redmi Note 15 (China)',
      'Redmi 15C 4G',
      'Redmi 15 4G',
      'Redmi 15',
      'Poco M7 Plus',
      'Poco M7 4G',
      'Redmi K80 Ultra',
      'Poco F7',
      'Mix Flip 2',
      'Civi 5 Pro',
      '15S Pro',
      'Redmi Turbo 4 Pro',
      'Poco C71',
      'Redmi Note 14S',
      'Redmi A5',
      'Redmi 13x',
      'Poco M7',
      'Poco F7 Ultra',
      'Poco F7 Pro',
      '15 Ultra',
      'Redmi Turbo 4',
      'Redmi Note 14 Pro+ 5G',
      'Redmi Note 14 Pro 5G',
      'Redmi Note 14 Pro 4G',
      'Redmi Note 14 5G',
      'Redmi Note 14 4G',
      'Redmi 14C 5G',
      'Poco X7 Pro',
      'Poco X7',
      'Redmi Note 14 5G (India)',
      'Redmi 14C (China)',
      'Poco M7 Pro 5G',
      'Poco C75 5G',
      'Redmi K80 Pro',
      'Redmi K80',
      'Redmi A4',
      'Redmi A3 Pro',
      'Poco C75',
      '15 Pro',
      '15',
      'Redmi Note 14 Pro+ 5G (India)',
      'Redmi Note 14 Pro 5G (India)',
      'Redmi Note 14 5G (China)',
      'Redmi 14R',
      '14T Pro',
      '14T',
      'Redmi 14C',
      'Poco M6 Plus',
      'Redmi K70 Ultra',
      'Redmi 13 5G',
      'Mix Fold 4',
      'Mix Flip',
      'Redmi 13',
      'Poco M6 4G',
      '14 Civi',
      'Redmi Note 13R',
      'Redmi A3x',
      'Poco F6 Pro',
      'Poco F6',
      'Redmi Turbo 3',
      'Poco X6 Neo',
      'Poco C61',
      'Civi 4 Pro',
      'Redmi A3',
      '14 Ultra',
      'Redmi Note 13 Pro 4G',
      'Redmi Note 13 4G',
      'Redmi Note 13',
      'Poco X6 Pro',
      'Poco X6',
      'Poco M6 Pro 4G',
      'Redmi 13R',
      'Redmi 13C 5G',
      'Poco M6',
      'Redmi Note 13R Pro',
      'Redmi K70E',
      'Redmi K70 Pro',
      'Redmi K70',
      'Redmi 13C',
      'Poco C65',
      '14 Pro',
      '14',
      'Redmi Note 13 Pro+',
      'Redmi Note 13 Pro',
      'Redmi Note 13 (China)',
      '13T Pro',
      '13T',
      'Redmi K60 Ultra',
      'Redmi 12 5G',
      'Poco M6 Pro',
      'Mix Fold 3',
      'Redmi Note 12R Pro',
      'Redmi Note 12R',
      'Redmi 12',
      'Redmi Note 12T Pro',
      'Poco F5 Pro',
      'Poco F5',
      'Civi 3',
      'Poco C51',
      '13 Ultra',
      'Redmi Note 12S',
      'Redmi Note 12 Turbo',
      'Redmi Note 12 Pro 4G',
      'Redmi Note 12 4G',
      'Redmi A2+',
      'Redmi A2',
      'Poco X5 Pro',
      'Poco X5',
      'Poco C55',
      '13 Lite',
      'Poco C50',
      'Redmi Note 12 Pro Speed',
      'Redmi K60E',
      'Redmi K60 Pro',
      'Redmi K60',
      'Redmi 12C',
      '13 Pro',
      '13',
      'Redmi Note 12 Pro+',
      'Redmi Note 12 Pro',
      'Redmi Note 12 Discovery',
      'Redmi Note 12 (China)',
      'Redmi Note 12',
      '12T Pro',
      '12T',
      'Redmi Note 11R',
      'Redmi A1+',
      'Redmi A1',
      'Redmi 11 Prime 5G',
      'Redmi 11 Prime',
      'Poco M5s',
      'Poco M5 (India)',
      'Poco M5',
      'Civi 2',
      'Redmi Note 11 SE (India)',
      'Redmi K50 Ultra',
      'Poco M4 5G',
      'Mix Fold 2',
      'Redmi K50i',
      '12S Ultra',
      '12S Pro',
      '12S',
      '12 Pro (Dimensity)',
      '12 Lite',
      'Poco X4 GT',
      'Poco F4',
      'Poco C40',
      'Redmi Note 11T Pro+',
      'Redmi Note 11T Pro',
      'Redmi Note 11SE',
      'Redmi 10 Prime 2022',
      'Redmi 10 Power',
      'Poco M4 5G (India)',
      'Poco F4 GT',
      'Civi 1S',
      'Redmi Note 11S 5G',
      'Redmi Note 11E Pro',
      'Redmi Note 11E',
      'Redmi Note 11 Pro+ 5G (India)',
      'Redmi K50 Pro',
      'Redmi K50',
      'Redmi K40S',
      'Redmi 10C',
      'Redmi 10A',
      'Redmi 10 5G',
      'Redmi 10 (India)',
      'Black Shark 5 RS',
      'Black Shark 5 Pro',
      'Black Shark 5',
      'Redmi K50 Gaming',
      'Redmi 10 2022',
      'Poco X4 Pro 5G',
      'Poco M4 Pro',
      'Redmi Note 11S',
      'Redmi Note 11 Pro 5G',
      'Redmi Note 11 Pro',
      'Redmi Note 11',
      '11i HyperCharge 5G',
      '11i',
      '12X',
      '12 Pro',
      '12',
      'Redmi Note 11T 5G',
      'Redmi Note 11 4G',
      'Poco M4 Pro 5G',
      'Redmi Note 11 Pro+ 5G',
      'Redmi Note 11 Pro (China)',
      'Redmi Note 11 (China)',
      'Redmi Note 10 Lite',
      'Black Shark 4S Pro',
      'Black Shark 4S',
      'Redmi 9i Sport',
      'Redmi 9A Sport',
      'Redmi 9 Activ',
      'Redmi 10 Prime',
      'Poco C31',
      'Civi',
      '11T Pro',
      '11T',
      '11 Lite 5G NE',
      'Redmi 10',
      'Mix 4',
      'Redmi Note 10T 5G',
      'Poco X3 GT',
      'Poco F3 GT',
      'Redmi Note 8 2021',
      'Redmi Note 10 Pro (China)',
      'Poco M3 Pro 5G',
      'Poco M3 Pro',
      'Redmi K40 Gaming',
      'Poco M2 Reloaded',
      'Mi 11X Pro',
      'Mi 11X',
      'Redmi Note 10S',
      'Redmi Note 10 Pro Max',
      'Redmi Note 10 Pro (India)',
      'Redmi Note 10 Pro',
      'Redmi Note 10 5G',
      'Redmi Note 10',
      'Poco X3 Pro',
      'Poco F3',
      'Mi Mix Fold',
      'Mi 11i',
      'Mi 11 Ultra',
      'Mi 11 Pro',
      'Mi 11 Lite 5G',
      'Mi 11 Lite',
      'Mi 10S',
      'Black Shark 4 Pro',
      'Black Shark 4',
      'Redmi K40 Pro+',
      'Redmi K40 Pro',
      'Redmi K40',
      'Redmi Note 9T',
      'Redmi 9T',
      'Mi 10i 5G',
      'Redmi 9 Power',
      'Mi 11',
      'Redmi Note 9 Pro 5G',
      'Redmi Note 9 5G',
      'Redmi Note 9 4G',
      'Poco M3',
      'Redmi K30S',
      'Poco C3',
      'Redmi 9i',
      'Redmi 9AT',
      'Poco X3 NFC',
      'Poco X3',
      'Poco M2',
      'Mi 10T Pro 5G',
      'Mi 10T Lite 5G',
      'Mi 10T 5G',
      'Redmi K30 Ultra',
      'Redmi 9C NFC',
      'Redmi 9 Prime',
      'Redmi 9 (India)',
      'Mi 10 Ultra',
      'Poco M2 Pro',
      'Black Shark 3S',
      'Redmi 9C',
      'Redmi 9A',
      'Redmi 9',
      'Redmi K30i 5G',
      'Redmi K30 5G Racing',
      'Redmi 10X Pro 5G',
      'Redmi 10X 5G',
      'Redmi 10X 4G',
      'Poco F2 Pro',
      'Redmi Note 9 Pro',
      'Redmi Note 9',
      'Redmi 8A Pro',
      'Mi Note 10 Lite',
      'Mi 10 Youth 5G',
      'Redmi Note 9S',
      'Redmi Note 9 Pro Max',
      'Redmi Note 9 Pro (India)',
      'Redmi K30 Pro Zoom',
      'Redmi K30 Pro',
      'Mi 10 Lite 5G',
      'Black Shark 3 Pro',
      'Black Shark 3',
      'Redmi 8A Dual',
      'Poco X2',
      'Mi 10 Pro 5G',
      'Mi 10 5G',
      'Redmi K30 5G',
      'Redmi K30',
      'Redmi Note 8T',
      'Mi Note 10 Pro',
      'Mi Note 10',
      'Mi CC9 Pro',
      'Redmi 8',
      'Redmi K20 Pro Premium',
      'Redmi 8A',
      'Mi Mix Alpha',
      'Mi 9 Pro 5G',
      'Mi 9 Pro',
      'Mi 9 Lite',
      'Redmi Note 8 Pro',
      'Redmi Note 8',
      'Mi 9T Pro',
      'Mi CC9e',
      'Mi CC9',
      'Mi A3',
      'Black Shark 2 Pro',
      'Mi 9T',
      'Redmi Note 7S',
      'Redmi K20 Pro',
      'Redmi K20',
      'Redmi 7A',
      'Redmi Y3',
      'Redmi 7',
      'Black Shark 2',
      'Redmi Note 7 Pro',
      'Mi Mix 3 5G',
      'Mi 9 SE',
      'Mi 9 Explorer',
      'Mi 9',
      'Redmi Note 7',
      'Redmi Go',
      'Mi Play',
      'Mi Mix 3',
      'Black Shark Helo',
      'Redmi Note 6 Pro',
      'Mi 8 Pro',
      'Mi 8 Lite',
      'Pocophone F1',
      'Mi Max 3',
      'Mi A2 Lite (Redmi 6 Pro)',
      'Mi A2 (Mi 6X)',
      'Redmi 6A',
      'Redmi 6',
      'Redmi S2 (Redmi Y2)',
      'Mi 8 SE',
      'Mi 8 Explorer',
      'Mi 8',
      'Black Shark',
      'Redmi Note 5 AI Dual Camera',
      'Mi Mix 2S',
      'Redmi Note 5 Pro',
      'Redmi 5 Plus (Redmi Note 5)',
      'Redmi 5',
      'Redmi Y1 Lite',
      'Redmi Y1 (Note 5A)',
      'Redmi 5A',
      'Mi Note 3',
      'Mi Mix 2',
      'Mi A1 (Mi 5X)',
      'Redmi 4 (4X)',
      'Mi Max 2',
      'Mi 6',
      'Redmi Note 4X',
      'Mi 5c',
      'Redmi Note 4',
      'Redmi 4A',
      'Redmi 4 Prime',
      'Redmi 4 (China)',
      'Mi Note 2',
      'Mi Mix',
      'Mi 5s Plus',
      'Mi 5s',
      'Redmi Note 4 (MediaTek)',
      'Redmi 3s Prime',
      'Redmi Pro',
      'Redmi 3x',
      'Redmi 3s',
      'Mi Max',
      'Redmi 3 Pro',
      'Mi 5',
      'Mi 4s',
      'Redmi Note 3',
      'Redmi 3',
      'Redmi Note Prime',
      'Redmi Note 3 (MediaTek)',
      'Redmi 2 Pro',
      'Mi 4c',
      'Redmi Note 2',
      'Redmi 2 Prime',
      'Mi 4i',
      'Redmi 2A',
      'Redmi 2',
      'Mi Note Pro',
      'Mi Note',
      'Mi 4 LTE',
      'Redmi Note 4G',
      'Mi 4',
      'Redmi 1S',
      'Redmi Note',
      'Mi 3',
      'Redmi',
      'Mi 2S',
      'Mi 2',
      'Mi 1S',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  OnePlus: {
    popular: ['V Fold', 'Open 2', 'Nord 2 Lite', '9E', 'Turbo 6X Pro'],
    all: [
      'V Fold',
      'Open 2',
      'Nord 2 Lite',
      '9E',
      'Turbo 6X Pro',
      'Turbo 6X',
      'N6',
      'Nord CE6 Lite',
      'Nord CE6',
      'Nord 6',
      'Ace 6 Ultra',
      '15T',
      'Turbo 6V',
      'Turbo 6',
      'Ace 6T',
      '15R',
      'Ace 6',
      '15',
      'Nord CE5',
      'Nord 5',
      '13s',
      'Ace 5 Ultra',
      'Ace 5 Racing',
      '13T',
      '13R',
      'Ace 5 Pro',
      'Ace 5',
      '13',
      'Nord 4',
      'Nord CE4 Lite (India)',
      'Nord CE4 Lite',
      'Ace 3 Pro',
      'Nord CE4',
      'Ace 3V',
      'Nord N30 SE',
      'Ace 3',
      '12R',
      '12',
      'Open',
      'Ace 2 Pro',
      'Nord CE3',
      'Nord 3',
      'Nord N30',
      'Nord CE 3 Lite',
      'Ace 2V',
      'Ace 2',
      '11R',
      '11',
      'Nord N300',
      'Nord N20 SE',
      'Ace Pro',
      '10T',
      'Nord 2T',
      'Ace Racing',
      'Nord N20 5G',
      'Nord CE 2 Lite 5G',
      'Ace',
      '10R 150W',
      '10R',
      'Nord CE 2 5G',
      '10 Pro',
      '9RT 5G',
      'Nord 2 5G',
      'Nord N200 5G',
      'Nord CE 5G',
      '9R',
      '9 Pro',
      '9',
      'Nord N100',
      'Nord N10 5G',
      '8T+ 5G',
      '8T',
      'Nord',
      '8 Pro',
      '8 5G UW (Verizon)',
      '8 5G (T-Mobile)',
      '8',
      '7T Pro 5G McLaren',
      '7T Pro',
      '7T',
      '7 Pro 5G',
      '7 Pro',
      '7',
      '6T McLaren',
      '6T',
      '6',
      '5T',
      '5',
      '3T',
      '3',
      'X',
      '2',
      'One',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Huawei: {
    popular: ['Enjoy 90', 'Enjoy 90 Plus', 'Enjoy 90 Pro Max', 'Enjoy 90m Plus', 'Mate 80 Pro Max Wind'],
    all: [
      'Enjoy 90',
      'Enjoy 90 Plus',
      'Enjoy 90 Pro Max',
      'Enjoy 90m Plus',
      'Mate 80 Pro Max Wind',
      'MatePad Pro Max',
      'nova 15 Max',
      'nova 16 Pro',
      'nova 16 Ultra',
      'nova Y74',
      'Pura 80 Pro Max',
      'Pura 90',
      'Pura 90 Pro 5G',
      'Pura 90 Pro Max',
      'Pura 90s Pro',
      'Pura 90s Pro Max',
      'Pura X Max',
      'Enjoy 70X',
      'Mate 80',
      'Mate 80 Pro',
      'Mate 80 Pro Max',
      'Mate 80 RS Ultimate',
      'Mate X7',
      'Mate XTs Ultimate',
      'MatePad 11.5 (2025)',
      'MatePad 11.5 (2026)',
      'MatePad 11.5 S (2025)',
      'MatePad 12 X (2025)',
      'MatePad Air (2025)',
      'MatePad Mini',
      'nova 14 Lite',
      'nova 14i',
      'nova 15',
      'nova 15 Pro',
      'nova 15 Ultra',
      'Pura X',
      'Enjoy 70z',
      'Mate 70',
      'Mate 70 Pro',
      'Mate 70 Pro+',
      'Mate X6',
      'Mate XT Ultimate',
      'nova 12 SE',
      'nova 12i',
      'nova 12s',
      'nova 13',
      'nova 13 Pro',
      'nova 13i',
      'nova Flip',
      'nova Y72',
      'Pocket 2',
      'Pura 70',
      'Pura 70 Pro',
      'Pura 70 Pro+',
      'Pura 70 Ultra',
      'Enjoy 60',
      'Enjoy 60X',
      'Enjoy 70',
      'Mate 60',
      'Mate 60 Pro',
      'Mate 60 Pro+',
      'Mate 60 RS Ultimate',
      'Mate X3',
      'Mate X5',
      'nova 10 Youth',
      'nova 11',
      'nova 11 Pro',
      'nova 11 SE',
      'nova 11 Ultra',
      'nova 11i',
      'nova 12',
      'nova 12 Lite',
      'nova 12 Pro',
      'nova 12 Ultra',
      'nova Y71',
      'nova Y91',
      'P60',
      'P60 Art',
      'P60 Pro',
      'Enjoy 50',
      'Enjoy 50 Pro',
      'Enjoy 50z',
      'Hi nova 9z',
      'Mate 40E Pro',
      'Mate 50',
      'Mate 50 Pro',
      'Mate 50 RS Porsche Design',
      'Mate 50E',
      'Mate Xs 2',
      'nova 10',
      'nova 10 Pro',
      'nova 10 SE',
      'nova 10z',
      'nova 9 SE',
      'nova 9 SE 5G',
      'nova Y61',
      'nova Y70 Plus',
      'nova Y90',
      'P50E',
      'Pocket S',
      'Enjoy 20e',
      'Maimang 10 SE 5G',
      'Mate 40 Pro 4G',
      'Mate 40E',
      'Mate 40E 4G',
      'Mate X2',
      'Mate X2 4G',
      'nova 8',
      'nova 8 Pro 4G',
      'nova 8 SE 4G',
      'nova 8 SE Vitality Edition',
      'nova 8 SE Youth',
      'nova 8i',
      'nova 9',
      'nova 9 Pro',
      'nova Y60',
      'P40 4G',
      'P50',
      'P50 Pocket',
      'P50 Pro',
      'Enjoy 20 5G',
      'Enjoy 20 Plus 5G',
      'Enjoy 20 Pro',
      'Enjoy 20 SE',
      'Enjoy Z 5G',
      'Mate 30E Pro 5G',
      'Mate 40',
      'Mate 40 Pro',
      'Mate 40 Pro+',
      'Mate 40 RS Porsche Design',
      'Mate Xs',
      'nova 7 5G',
      'nova 7 Pro 5G',
      'nova 7 SE',
      'nova 7 SE 5G Youth',
      'nova 7i',
      'nova 8 5G',
      'nova 8 Pro 5G',
      'nova 8 SE',
      'P smart 2020',
      'P smart 2021',
      'P Smart S',
      'P30 lite New Edition',
      'P30 Pro New Edition',
      'P40',
      'P40 lite',
      'P40 lite 5G',
      'P40 lite E',
      'P40 Pro',
      'P40 Pro+',
      'Y5p',
      'Y6p',
      'Y6s (2019)',
      'Y7a',
      'Y7p',
      'Y8p',
      'Y8s',
      'Y9a',
      'Enjoy 10',
      'Enjoy 10 Plus',
      'Enjoy 10s',
      'Enjoy 9e',
      'Enjoy 9s',
      'Mate 20 X (5G)',
      'Mate 30',
      'Mate 30 5G',
      'Mate 30 Pro',
      'Mate 30 Pro 5G',
      'Mate 30 RS Porsche Design',
      'Mate X',
      'nova 4e',
      'nova 5',
      'nova 5 Pro',
      'nova 5i',
      'nova 5i Pro',
      'nova 5T',
      'nova 5z',
      'nova 6',
      'nova 6 5G',
      'nova 6 SE',
      'P smart Pro 2019',
      'P Smart Z',
      'P20 lite (2019)',
      'P30',
      'P30 lite',
      'P30 Pro',
      'Y5 (2019)',
      'Y6 (2019)',
      'Y6 Pro (2019)',
      'Y7 (2019)',
      'Y7 Prime (2019)',
      'Y7 Pro (2019)',
      'Y9 Prime (2019)',
      'Y9s',
      'Enjoy 8',
      'Enjoy 9',
      'Mate 20',
      'Mate 20 Lite',
      'Mate 20 Pro',
      'Mate 20 RS Porsche Design',
      'Mate 20 X',
      'Mate RS Porsche Design',
      'nova 3',
      'nova 3i',
      'nova 4',
      'P Smart 2019',
      'P Smart+',
      'P20',
      'P20 Lite',
      'P20 Pro',
      'Y Max',
      'Y3 (2018)',
      'Y5 lite (2018)',
      'Y5 Prime (2018)',
      'Y6 (2018)',
      'Y7 Prime (2018)',
      'Y9 (2018)',
      'Y9 (2019)',
      'Enjoy 7 Plus',
      'Mate 10',
      'Mate 10 Lite',
      'Mate 10 Porsche Design',
      'Mate 10 Pro',
      'nova 2',
      'nova 2 plus',
      'nova 2s',
      'P smart',
      'P10',
      'P10 Lite',
      'P10 Plus',
      'P8 Lite 2017',
      'P9 lite mini',
      'Y3 (2017)',
      'Y5 (2017)',
      'Y6 (2017)',
      'Y7',
      'Y7 Prime',
      'Enjoy 6',
      'Enjoy 6s',
      'G9 Plus',
      'Mate 9',
      'Mate 9 Lite',
      'Mate 9 Porsche Design',
      'Mate 9 Pro',
      'nova',
      'nova plus',
      'P9',
      'P9 lite',
      'P9 Plus',
      'Y3II',
      'Y5II',
      'Y6II Compact',
      'Ascend Y540',
      'Enjoy 5',
      'Enjoy GR3 5s',
      'G7 Plus',
      'G8',
      'Mate 8',
      'Mate S',
      'Nexus 6P',
      'P8',
      'P8 Lite',
      'P8lite ALE-L04',
      'P8max',
      'SnapTo',
      'Y360',
      'Y560',
      'Y6',
      'Y625',
      'Y635',
      'Ascend G6',
      'Ascend G6 4G',
      'Ascend G620s',
      'Ascend G630',
      'Ascend G7',
      'Ascend G730',
      'Ascend GX1',
      'Ascend Mate2 4G',
      'Ascend Mate7',
      'Ascend Mate7 Monarch',
      'Ascend P6 S',
      'Ascend P7',
      'Ascend P7 mini',
      'Ascend P7 Sapphire Edition',
      'Ascend Plus',
      'Ascend Y221',
      'Ascend Y330',
      'Ascend Y520',
      'Ascend Y530',
      'Ascend Y550',
      'Ascend Y600',
      'Y300II',
      'Ascend D2',
      'Ascend G350',
      'Ascend G510',
      'Ascend G525',
      'Ascend G526',
      'Ascend G615',
      'Ascend G700',
      'Ascend G740',
      'Ascend Mate',
      'Ascend P2',
      'Ascend P6',
      'Ascend W1',
      'Ascend W2',
      'Ascend Y210D',
      'Ascend Y220',
      'Ascend Y300',
      'Ascend Y320',
      'Ascend Y511',
      'G610s',
      'Ascend D quad',
      'Ascend D quad XL',
      'Ascend D1',
      'Ascend D1 XL U9500E',
      'Ascend G300',
      'Ascend G312',
      'Ascend G330',
      'Ascend G330D U8825D',
      'Ascend G500',
      'Ascend G600',
      'Ascend P1',
      'Ascend P1 LTE',
      'Ascend P1 XL U9200E',
      'Ascend P1s',
      'Ascend Y100',
      'Ascend Y200',
      'Ascend Y201 Pro',
      'Fusion 2 U8665',
      'Fusion U8652',
      'Summit',
      'Impulse 4G',
      'T8300',
      'U8180 IDEOS X1',
      'U8350 Boulder',
      'U8510 IDEOS X3',
      'U8520 Duplex',
      'U8650 Sonic',
      'U8800 Pro',
      'U8850 Vision',
      'U8100',
      'U8110',
      'U8150 IDEOS',
      'U8300',
      'U8500 IDEOS X2',
      'U8800 IDEOS X5',
      'U9000 IDEOS X6',
      'U8220',
      'U8230',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Motorola: {
    popular: ['W231', 'W209', 'V980', 'V975', 'V878'],
    all: [
      'W231',
      'W209',
      'V980',
      'V975',
      'V878',
      'V872',
      'v8088',
      'V80',
      'V750',
      'V70',
      'V690',
      'V66i',
      'V66',
      'V635',
      'V620',
      'V60i',
      'V60',
      'V560',
      'V557',
      'V555',
      'V547',
      'V535',
      'V525',
      'V501',
      'V500',
      'V50',
      'V400p',
      'V3x',
      'V3690',
      'V3688',
      'V361',
      'V360',
      'V303',
      'V300',
      'V295',
      'V291',
      'V290',
      'V235',
      'V230',
      'V2288',
      'V226',
      'V220',
      'V188',
      'V186',
      'V180',
      'V176',
      'V171',
      'V150',
      'V1050',
      'V1000',
      'V.box(V100)',
      'Timeport P7389',
      'Timeport L7089',
      'Timeport 280',
      'Timeport 260',
      'Timeport 250',
      'Talkabout T2288',
      'Talkabout T192',
      'Talkabout T191',
      'T725',
      'T180',
      'StarTAC Rainbow',
      'StarTAC 85',
      'StarTAC 75+',
      'StarTAC 75',
      'StarTAC 130',
      'SLVR L7',
      'SlimLite',
      'RAZR V3',
      'PEBL U6',
      'MPx220',
      'MPx200',
      'MPx100',
      'MPx',
      'Motosmart Me XT303',
      'Motoluxe XT389',
      'MOTOACTV W450',
      'M3888',
      'M3788',
      'M3688',
      'M3588',
      'M3288',
      'M3188',
      'L6',
      'L2',
      'E770',
      'E680',
      'E398',
      'E390',
      'E380',
      'E378i',
      'E375',
      'E365',
      'E1120',
      'E1070',
      'E1060',
      'E1000',
      'Defy Mini XT321',
      'd520',
      'cd930',
      'cd920',
      'C980',
      'C975',
      'C650',
      'C550',
      'C450',
      'C390',
      'C380/C385',
      'C350',
      'C336',
      'C333',
      'C332',
      'C331',
      'C289',
      'C261',
      'C257',
      'C250',
      'C230',
      'C205',
      'C200',
      'C168',
      'C155',
      'C139',
      'C123',
      'C118',
      'C117',
      'C116',
      'C115',
      'C113a',
      'C113',
      'Accompli 388',
      'Accompli 009',
      'Accompli 008',
      'A925',
      'A920',
      'A840',
      'A835',
      'A830',
      'A780',
      'A768i',
      'A760',
      'A668',
      'A630',
      'A6188',
      'A388c',
      'A1010',
      'A1000',
      'Razr+ 2026',
      'Razr Ultra 2026',
      'Razr 70+',
      'Razr 70 Ultra',
      'Razr 70',
      'Razr 2026',
      'Signature',
      'G96',
      'Razr+ 2025',
      'Razr Ultra 2025',
      'Razr 60 Ultra',
      'Razr 60',
      'Razr 2025',
      'ThinkPhone 25',
      'S50 Neo',
      'Razr+ 2024',
      'Razr 50 Ultra',
      'Razr 50',
      'Razr 2024',
      'Razr 40 Ultra',
      'Razr 40',
      'Defy 2',
      'ThinkPhone',
      'Razr 2022',
      'G Pure',
      'Defy (2021)',
      'Razr 5G',
      'Razr 2019',
      'P30',
      'Luge',
      'RAZR D3 XT919',
      'RAZR D1',
      'Electrify M XT905',
      'RAZR M XT905',
      'RAZR i XT890',
      'RAZR HD XT925',
      'Photon Q 4G LTE XT897',
      'MotoGO TV EX440',
      'Electrify 2 XT881',
      'DEFY XT XT556',
      'Defy Pro XT560',
      'XT760',
      'RAZR V XT889',
      'RAZR V XT885',
      'Motoluxe MT680',
      'RAZR V MT887',
      'MOTOSMART MIX XT550',
      'MOTOKEY 3-CHIP EX117',
      'MotoGO EX430',
      'XT390',
      'RAZR MAXX',
      'Motosmart Flip XT611',
      'DEFY XT535',
      'GLEAM+ WX308',
      'Motoluxe',
      'Defy Mini XT320',
      'XT928',
      'XT532',
      'WX306',
      'MT917',
      'Fire',
      'Motokey Social',
      'XT319',
      'RAZR XT910',
      'ME632',
      'Admiral XT603',
      'EX226',
      'PRO+',
      'MOTOKEY Mini EX109',
      'FIRE XT',
      'EX212',
      'EX119',
      'DEFY+',
      'WX294',
      'SPICE Key XT317',
      'SPICE Key',
      'MOTOKEY XT EX118',
      'FIRE XT311',
      'EX232',
      'WILDER',
      'Triumph',
      'Photon 4G MB855',
      'MOTOKEY Mini EX108',
      'XPRT MB612',
      'PRO',
      'GLEAM',
      'Cliq 2',
      'XT301',
      'MT810lx',
      'A1260',
      'SPICE XT300',
      'MOTOTV EX245',
      'FLIPSIDE MB508',
      'EX210',
      'EX201',
      'EX128',
      'EX122',
      'CITRUS WX445',
      'BRAVO MB520',
      'XT810',
      'XT806',
      'EX300',
      'EX115',
      'EX112',
      'DEFY',
      'CUPE',
      'Grasp WX404',
      'Rambler',
      'Quench XT5 XT502',
      'Quench XT3 XT502',
      'CHARM',
      'A1680',
      'FlipOut',
      'ES400',
      'WX295',
      'WX290',
      'WX265',
      'WX260',
      'WX181',
      'WX161',
      'QUENCH',
      'XT720 MOTOROI',
      'BACKFLIP',
      'XT800 ZHISHANG',
      'XT701',
      'WX395',
      'WX390',
      'WX288',
      'WX280',
      'MT710 ZHILING',
      'WX180',
      'WX160',
      'Motocubo A45',
      'E11',
      'DEXT MB220',
      'ROKR ZN50',
      'L800t',
      'Karma QA1',
      'W7 Active Edition',
      'ROKR W6',
      'A1210',
      'ZN300',
      'MC55',
      'W233 Renew',
      'Tundra VA76r',
      'A3100',
      'A3000',
      'VE66',
      'COCKTAIL VE70',
      'Q 11',
      'EM35',
      'Aura',
      'VE538',
      'A1890',
      'ZN200',
      'W396',
      'EM30',
      'EM28',
      'EM25',
      'W388',
      'VE75',
      'RAZR2 V9x',
      'PEBL VU20',
      'ZN5',
      'A810',
      'A1800',
      'A1600',
      'Z9',
      'W177',
      'Z6w',
      'W181',
      'W161',
      'W270',
      'W230',
      'Z6c',
      'W377',
      'W213',
      'W180',
      'W160',
      'U9',
      'W490',
      'ROKR W5',
      'ROKR E8',
      'RIZR Z10',
      'PEBL U3',
      'RAZR2 V9',
      'RAZR2 V8',
      'W395',
      'W380',
      'W360',
      'W218',
      'V1100',
      'W510',
      'W215',
      'W205',
      'SLVR L9',
      'RIZR Z8',
      'Q 9h',
      'KRZR K3',
      'ROKR Z6',
      'ROKR E6',
      'SLVR L7e',
      'RIZR Z3',
      'RAZR V3xx',
      'RAZR maxx V6',
      'KRZR K1',
      'W375',
      'W208',
      'MOTOFONE F3',
      'W220',
      'V195',
      'V191',
      'ROKR E2',
      'A1200',
      'RAZR V3i',
      'ROKR E1',
      'Q8',
      'A910',
      'A732',
      'A728',
      'E895',
      'E680i',
      'V600',
      'T720i',
      'T720',
      'E360',
      'T190',
      'C300',
      'Moto Z4 Force',
      'MOTO XT702',
      'Moto X5',
      'Moto G36',
      'Edge 70 Ultra',
      'Droid XTreme',
      'Droid Bionic Targa',
      'Moto G77 Power',
      'Edge 70 Max',
      'Moto G Max',
      'Edge 70 Pro+',
      'Edge (2026)',
      'Moto G87',
      'Moto G47',
      'Moto G37 Power',
      'Moto G37',
      'Moto G Stylus (2026)',
      'Edge 70 Pro',
      'Edge 70 Fusion+',
      'Edge 70 Fusion',
      'Moto G77',
      'Moto G67',
      'Moto G17 Power',
      'Moto G17',
      'Moto G Power (2026)',
      'Moto G67 Power',
      'Moto G57 Power',
      'Moto G57',
      'Moto G100S',
      'Moto G Play (2026)',
      'Moto G (2026)',
      'Moto G100',
      'Edge 70',
      'Moto G06 Power',
      'Moto G06',
      'Edge 60 Neo',
      'Moto G86 Power',
      'Moto G86',
      'Moto G56',
      'Edge (2025)',
      'Moto G Stylus 5G (2025)',
      'Edge 60s',
      'Edge 60 Stylus',
      'Edge 60 Pro',
      'Edge 60 Fusion',
      'Edge 60',
      'Moto G Power (2025)',
      'Moto G (2025)',
      'Moto G15 Power',
      'Moto G15',
      'Moto G05',
      'Moto E15',
      'Moto G75',
      'Moto S50',
      'Moto G55',
      'Moto G45',
      'Moto G35',
      'Edge 50 Neo',
      'Edge 50',
      'Moto G85',
      'Moto E14',
      'Edge (2024)',
      'Moto X50 Ultra',
      'Moto G Stylus 5G (2024)',
      'Moto G64',
      'Moto G04s',
      'Edge 50 Ultra',
      'Edge 50 Pro',
      'Edge 50 Fusion',
      'Moto G Power (2024)',
      'Moto G (2024)',
      'Moto G24 Power',
      'Moto G24',
      'Moto G04',
      'Moto G Play (2024)',
      'Moto G34',
      'Edge (2023)',
      'Moto G54 Power',
      'Moto G54',
      'Edge 40 Neo',
      'Moto G84',
      'Moto G14',
      'Moto G Stylus 5G (2023)',
      'Moto G Stylus (2023)',
      'Moto G (2023)',
      'Edge+ (2023)',
      'Edge 40',
      'Moto G Power 5G',
      'Edge 40 Pro',
      'Moto G73',
      'Moto G23',
      'Moto G13',
      'Moto E13',
      'Moto X40',
      'Moto G53',
      'Moto G Play (2023)',
      'Moto E32 (India)',
      'Moto G72',
      'Moto E22i',
      'Moto E22',
      'Edge 30 Ultra',
      'Edge 30 Neo',
      'Edge 30 Fusion',
      'Moto X30 Pro',
      'Moto S30 Pro',
      'Moto G62 (India)',
      'Moto E22s',
      'Edge (2022)',
      'Moto G32',
      'Moto G62 5G',
      'Moto G42',
      'Moto G82',
      'Moto G71s',
      'Moto E32s',
      'Moto E32',
      'Moto G52',
      'Moto G Stylus 5G (2022)',
      'Moto G (2022)',
      'Edge 30',
      'Moto G22',
      'Moto G Stylus (2022)',
      'Edge+ 5G UW (2022)',
      'Edge 30 Pro',
      'Edge X30',
      'Edge S30',
      'Moto G71 5G',
      'Moto G51 5G',
      'Moto G41',
      'Moto G31',
      'Moto G200 5G',
      'Moto G Power (2022)',
      'Moto E30',
      'Moto E40',
      'Edge 5G UW (2021)',
      'Moto E20',
      'Moto G60S',
      'Moto G50 5G',
      'Edge 20 Fusion',
      'Edge (2021)',
      'one 5G UW ace',
      'Edge 20 Pro',
      'Edge 20 Lite',
      'Edge 20',
      'Moto G Stylus 5G',
      'Moto G60',
      'Moto G40 Fusion',
      'Moto G20',
      'Moto G50',
      'Moto G100 (2021)',
      'Moto G10 Power',
      'Moto G30',
      'Moto G10',
      'Moto E7i Power',
      'Moto E7 Power',
      'Moto E6i',
      'One 5G Ace',
      'Moto G Stylus (2021)',
      'Moto G Power (2021)',
      'Moto G Play (2021)',
      'Edge S',
      'Moto G9 Power',
      'Moto G 5G',
      'Moto E7',
      'One 5G UW',
      'One 5G',
      'Moto G9 Plus',
      'Moto E7 Plus',
      'Moto G9 Play',
      'Moto G9 (India)',
      'One Vision Plus',
      'One Fusion',
      'Moto G 5G Plus',
      'One Fusion+',
      'Moto G Fast',
      'Moto E (2020)',
      'Moto G Pro',
      'Moto G8 Power Lite',
      'Edge+ (2020)',
      'Edge',
      'Moto G8',
      'Moto E6s (2020)',
      'Moto G8 Power',
      'Moto G Stylus',
      'Moto G Power',
      'One Hyper',
      'One Macro',
      'Moto G8 Plus',
      'Moto G8 Play',
      'Moto E6 Play',
      'One Zoom',
      'Moto E6 Plus',
      'One Action',
      'Moto E6',
      'One Vision',
      'Moto Z4',
      'Moto G7 Power',
      'Moto G7 Plus',
      'Moto G7 Play',
      'Moto G7',
      'One Power (P30 Note)',
      'One (P30 Play)',
      'Moto Z3',
      'Moto E5 Play Go',
      'Moto Z3 Play',
      'Moto E5 Cruise',
      'Moto G6 Plus',
      'Moto G6 Play',
      'Moto G6',
      'Moto E5 Plus',
      'Moto E5 Play',
      'Moto E5',
      'Moto X4',
      'Moto G5S Plus',
      'Moto G5S',
      'Moto Z2 Force',
      'Moto Z2 Play',
      'Moto E4 Plus (USA)',
      'Moto E4 Plus',
      'Moto E4 (USA)',
      'Moto E4',
      'Moto C Plus',
      'Moto C',
      'Moto G5 Plus',
      'Moto G5',
      'Moto M',
      'Moto E3 Power',
      'Moto Z Play',
      'Moto E3',
      'Moto Z Force',
      'Moto Z',
      'Moto G4 Plus',
      'Moto G4 Play',
      'Moto G4',
      'Moto X Force',
      'Moto G Turbo',
      'Droid Turbo 2',
      'Droid Maxx 2',
      'Moto X Style',
      'Moto X Play Dual SIM',
      'Moto X Play',
      'Moto G Dual SIM (3rd gen)',
      'Moto G (3rd gen)',
      'Moto G 4G (2nd gen)',
      'Moto E Dual SIM (2nd gen)',
      'Moto E (2nd gen)',
      'Moto G 4G Dual SIM (2nd gen)',
      'Moto Maxx',
      'Nexus 6',
      'DROID Turbo',
      'Moto X (2nd Gen)',
      'Moto G Dual SIM (2nd gen)',
      'Moto G (2nd gen)',
      'Moto G 4G',
      'Moto E Dual SIM',
      'Moto E',
      'Moto G Dual SIM',
      'Moto G',
      'Moto X',
      'DROID Ultra',
      'DROID Mini',
      'DROID Maxx',
      'DROID RAZR MAXX HD',
      'DROID RAZR M',
      'DROID RAZR HD',
      'ATRIX HD MB886',
      'ATRIX TV XT687',
      'ATRIX TV XT682',
      'DROID RAZR MAXX',
      'DROID 4 XT894',
      'MOTO XT615',
      'DROID RAZR XT912',
      'ATRIX 2 MB865',
      'MILESTONE 3 XT860',
      'DROID 3',
      'MOTO XT316',
      'MOTO MT870',
      'Milestone XT883',
      'MOTO XT882',
      'MOTO MT620',
      'DROID X2',
      'DROID X ME811',
      'DROID BIONIC XT875',
      'DROID BIONIC XT865',
      'ATRIX 4G',
      'ATRIX',
      'MOTO ME525',
      'MILESTONE 2 ME722',
      'DROID 2 Global',
      'MOTO MT716',
      'DROID PRO XT610',
      'MILESTONE 2',
      'DROID 2',
      'MILESTONE XT720',
      'DROID X',
      'MILESTONE',
    ],
    storages: ['32GB', '64GB', '128GB', '256GB'],
  },
  Sony: {
    popular: ['D 2403', 'CMD Z7', 'CMD Z5', 'CMD Z1 plus', 'CMD Z1'],
    all: [
      'D 2403',
      'CMD Z7',
      'CMD Z5',
      'CMD Z1 plus',
      'CMD Z1',
      'CMD J70',
      'CMD J7',
      'CMD J6',
      'CMD J5',
      'CMD CD5',
      'CMD C1',
      'CM-DX 2000',
      'CM-DX 1000',
      'CMD MZ5',
      'Xperia Z4 Ultra',
      'Xperia Z4 Compact',
      'Xperia X Ultra',
      'Xperia X Premium',
      'Xperia M Ultra',
      'Xperia H8541',
      'Xperia E1 II',
      'Xperia C670X',
      'Xperia 5 Plus',
      'Xperia 1 VIII',
      'Xperia 10 VII',
      'Xperia 1 VII',
      'Xperia 10 VI',
      'Xperia 1 VI',
      'Xperia 5 V',
      'Xperia 10 V',
      'Xperia 1 V',
      'Xperia 5 IV',
      'Xperia 10 IV',
      'Xperia 1 IV',
      'Xperia Pro-I',
      'Xperia 10 III Lite',
      'Xperia 5 III',
      'Xperia 10 III',
      'Xperia 1 III',
      'Xperia 5 II',
      'Xperia Pro',
      'Xperia L4',
      'Xperia 10 II',
      'Xperia 1 II',
      'Xperia 5',
      'Xperia L3',
      'Xperia 10 Plus',
      'Xperia 10',
      'Xperia 1',
      'Xperia XZ3',
      'Xperia XA2 Plus',
      'Xperia XZ2 Premium',
      'Xperia XZ2 Compact',
      'Xperia XZ2',
      'Xperia XA2 Ultra',
      'Xperia XA2',
      'Xperia L2',
      'Xperia R1 (Plus)',
      'Xperia XZ1 Compact',
      'Xperia XZ1',
      'Xperia XA1 Plus',
      'Xperia L1',
      'Xperia XZs',
      'Xperia XZ Premium',
      'Xperia XA1 Ultra',
      'Xperia XA1',
      'Xperia XZ',
      'Xperia X Compact',
      'Xperia XA Ultra',
      'Xperia E5',
      'Xperia XA Dual',
      'Xperia XA',
      'Xperia X Performance',
      'Xperia X',
      'Xperia Z5 Premium Dual',
      'Xperia Z5 Premium',
      'Xperia Z5 Dual',
      'Xperia Z5 Compact',
      'Xperia Z5',
      'Xperia M5 Dual',
      'Xperia M5',
      'Xperia C5 Ultra Dual',
      'Xperia C5 Ultra',
      'Xperia Z4v',
      'Xperia Z3+ dual',
      'Xperia Z3+',
      'Xperia C4 Dual',
      'Xperia C4',
      'Xperia M4 Aqua Dual',
      'Xperia M4 Aqua',
      'Xperia E4g Dual',
      'Xperia E4g',
      'Xperia E4 Dual',
      'Xperia E4',
      'Xperia Z3v',
      'Xperia Z3 Dual',
      'Xperia Z3 Compact',
      'Xperia Z3',
      'Xperia E3 Dual',
      'Xperia E3',
      'Xperia M2 Aqua',
      'Xperia C3 Dual',
      'Xperia C3',
      'Xperia Z2a',
      'Xperia T3',
      'Xperia Z2',
      'Xperia M2 dual',
      'Xperia M2',
      'Xperia Z1s',
      'Xperia Z1 Compact',
      'Xperia T2 Ultra dual',
      'Xperia T2 Ultra',
      'Xperia E1 dual',
      'Xperia E1',
      'Xperia Z1',
      'Xperia Z Ultra',
      'Xperia M',
      'Xperia C',
      'Xperia ZR',
      'Xperia SP',
      'Xperia L',
      'Xperia ZL',
      'Xperia Z',
      'Xperia E dual',
      'Xperia E',
      'Xperia T LTE',
      'Xperia V',
      'Xperia TX',
      'Xperia T',
      'Xperia SL',
      'Xperia LT29i Hayabusa',
      'Xperia J',
      'Xperia tipo dual',
      'Xperia tipo',
      'Xperia miro',
      'Xperia SX SO-05D',
      'Xperia GX SO-04D',
      'Xperia go',
      'Xperia acro S',
      'Xperia acro HD SOI12',
      'Xperia acro HD SO-03D',
      'Xperia ion HSPA',
      'Xperia sola',
      'Xperia neo L',
      'Xperia U',
      'Xperia P',
      'Xperia S',
      'Xperia ion LTE',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Honor: {
    popular: ['View', 'GT 2 Pro', 'X80 Pro Max', 'X70 Pro Max', '600 Smart'],
    all: [
      'View',
      'GT 2 Pro',
      'X80 Pro Max',
      'X70 Pro Max',
      '600 Smart',
      'X7e',
      'Win Turbo',
      'Play11 Plus',
      'Play10',
      'Play 80 Plus',
      'Play 70C',
      '600e',
      '600 Pro (China)',
      '600 (China)',
      'X80i',
      'X70 Refresh',
      'X5d Plus',
      'X5d',
      'Play 80 Pro',
      'Play 80',
      '600 Pro',
      '600',
      '500 Smart',
      'Magic V6',
      '600 Lite',
      'X6d',
      'Power2',
      'Magic8 RSR Porsche Design',
      'Magic8 Pro Air',
      'X8d',
      'Win RT',
      'Win',
      'Play 60A',
      'Magic8 Lite',
      '500 Pro (China)',
      '500',
      'X5c',
      'Play10A',
      'Magic8 Pro',
      'Magic8',
      'X9d',
      'X7d',
      'X5c Plus',
      'Play10 4G',
      '400 Smart 4G',
      'X7d 4G',
      'X7c',
      'Play10C',
      'Magic V Flip 2',
      '400 Smart',
      'X70',
      'Magic V5',
      'X6c',
      'X6b',
      '400 Pro (China)',
      '400 (China)',
      '400 Pro',
      '400',
      'X70i',
      'X60 GT',
      'Power',
      'Play 60',
      'GT Pro',
      '400 Lite',
      'X8c',
      'Magic7 Lite',
      'X9c Smart',
      'Magic7 RSR Porsche Design',
      'GT',
      '300 Ultra',
      '300 Pro',
      '300',
      'X9c',
      'Play9A',
      'X7c 4G',
      'X60 Pro',
      'X60',
      'X5b Plus',
      'X5b',
      'Magic7 Pro',
      'Magic7',
      'Play9T',
      'Play9C (China)',
      '200 Smart',
      'X60i',
      'Magic Vs3',
      'Magic V3',
      'X7b 5G (50 MP)',
      'X6b 4G',
      'Play 60 Plus',
      'Magic V Flip',
      '200 Pro',
      '200',
      'X7b 5G',
      '90 Smart',
      '200 Lite',
      'Magic6 Ultimate',
      'Magic6 RSR Porsche Design',
      'X50 GT',
      'Magic6 Pro',
      'Magic6',
      'Magic V2 RSR Porsche Design',
      'X8b',
      'X7b',
      'X50 Pro',
      'Magic6 Lite',
      '90 GT',
      'X50i+',
      '100 Pro',
      '100',
      'X9b',
      'Play 8T',
      'Play 50 Plus',
      'Magic Vs2',
      'X40 GT Racing',
      'V Purse',
      'X5 Plus',
      'X6a',
      'X50i',
      'X50',
      'Play 40',
      'Magic V2',
      '90 Lite',
      '90 Pro',
      '90',
      'Play7T Pro',
      'Play7T',
      'Magic5 Ultimate',
      '70 Lite',
      'X8a',
      'Magic5 Pro',
      'Magic5 Lite',
      'Magic5',
      'X9a',
      'X7a',
      'X5',
      '80 Pro Flat',
      '80 GT',
      'Magic Vs Ultimate',
      'Magic Vs',
      '80 SE',
      '80 Pro',
      '80',
      'X40 GT',
      'Play6C',
      'Play 40 Plus',
      'X6',
      'X40',
      'X8 5G',
      'X40i',
      'Play 30',
      '70 Pro+',
      '70 Pro',
      '70',
      'Play6T Pro',
      'Play6T',
      'X9 5G',
      'X9',
      'X8',
      'X7',
      'Magic4 Ultimate',
      'Magic4 Lite',
      'Magic4 Pro',
      'Magic4',
      '60 SE',
      'Magic V',
      'X30',
      'Play 30 Plus',
      '60 Pro',
      '60',
      'X30i',
      'X30 Max',
      'Play5 Youth',
      '50 Lite',
      'X20',
      'Play 5T Pro',
      'Magic3 Pro+',
      'Magic3 Pro',
      'Magic3',
      'X20 SE',
      '50 SE',
      '50 Pro',
      '50',
      'Play5 5G',
      'Play 5T Youth',
      'Play 20',
      'V40 Lite',
      'View40',
      'V40 5G',
      '10X Lite',
      '30i',
      'X10 Max 5G',
      '30 Youth',
      'Play4 Pro',
      'Play4',
      'X10 5G',
      '8S 2020',
      'Play 4T Pro',
      'Play 4T',
      '9X Lite',
      '9S',
      '9C',
      '9A',
      '8A 2020',
      '30 Pro+',
      '30 Pro',
      '30',
      '20e',
      'Play 9A',
      '8A Prime',
      '30S',
      'View30 Pro',
      'View30',
      'V30 Pro',
      'V30',
      '9X',
      '20 lite (China)',
      'Play 3e',
      'Play 3',
      '20S',
      '9X Pro',
      '9X (China)',
      '20 Pro',
      '20',
      '8S',
      '8A Pro',
      '20i',
      '20 lite',
      'Magic 2 3D',
      'Play 8A',
      'View 20',
      '10 Lite',
      'Magic 2',
      '8C',
      '8X Max',
      '8X',
      'Play',
      'Note 10',
      '9N (9i)',
      '7S',
      '7C',
      '10',
      '7A',
      'View 10',
      '9 Lite',
      '7X',
      '6C Pro',
      '9',
      '6A (Pro)',
      '8 Pro',
      'Magic',
      'Holly 3',
      '6X',
      'Note 8',
      '8',
      '5A',
      'V8',
      '5c',
      'Holly 2 Plus',
      '5X',
      '7i',
      '7',
      'Bee',
      '4C',
      '6 Plus',
      'Holly',
      '4X',
      '4 Play',
      '3C Play',
      '6',
      '3X Pro',
      '3C 4G',
      '3X G750',
      '3C',
      '3',
      '2',
      'U8860',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Nothing: {
    popular: ['Phone (4b)', 'Phone (4a) Pro', 'Phone (4a)', 'Phone (3a) Lite', 'Phone (3)'],
    all: [
      'Phone (4b)',
      'Phone (4a) Pro',
      'Phone (4a)',
      'Phone (3a) Lite',
      'Phone (3)',
      'CMF Phone 2 Pro',
      'Phone (3a) Pro',
      'Phone (3a)',
      'Phone (2a) Plus',
      'CMF Phone 1',
      'Phone (2a)',
      'Phone (2)',
      'Phone (1)',
    ],
    storages: ['128GB', '256GB', '512GB'],
  },
  Asus: {
    popular: ['Z801', 'V88i', 'V55', 'J502', 'E600'],
    all: [
      'Z801',
      'V88i',
      'V55',
      'J502',
      'E600',
      'Zenfone 12 Ultra',
      'ROG Phone 9 FE',
      'ROG Phone 9 Pro',
      'ROG Phone 9',
      'Zenfone 11 Ultra',
      'ROG Phone 8 Pro',
      'ROG Phone 8',
      'Zenfone 10',
      'ROG Phone 7 Ultimate',
      'ROG Phone 7',
      'ROG Phone 6 Diablo Immortal Edition',
      'ROG Phone 6D Ultimate',
      'ROG Phone 6D',
      'ROG Phone 6 Batman Edition',
      'Zenfone 9',
      'ROG Phone 6 Pro',
      'ROG Phone 6',
      'ROG Phone 5s Pro',
      'ROG Phone 5s',
      'Smartphone for Snapdragon Insiders',
      'Zenfone 8 Flip',
      'Zenfone 8',
      'ROG Phone 5 Ultimate',
      'ROG Phone 5 Pro',
      'ROG Phone 5',
      'Zenfone 7 Pro',
      'Zenfone 7',
      'ROG Phone 3 Strix',
      'ROG Phone 3',
      'ROG Phone II ZS660KL',
      'Zenfone 6 ZS630KL',
      'ZenFone Live (L2)',
      'Zenfone Max Shot ZB634KL',
      'Zenfone Max Plus (M2) ZB634KL',
      'Zenfone Max Pro (M2) ZB631KL',
      'Zenfone Max (M2) ZB633KL',
      'Zenfone Max (M1) ZB556KL',
      'ZenFone Lite (L1) ZA551KL',
      'ROG Phone ZS600KL',
      'ZenFone Live (L1) ZA550KL',
      'Zenfone Max Pro (M1) ZB601KL/ZB602K',
      'Zenfone Max (M1) ZB555KL',
      'Zenfone 5z ZS620KL',
      'Zenfone 5 ZE620KL',
      'Zenfone 5 Lite ZC600KL',
      'Zenfone Max Plus (M1) ZB570TL',
      'Zenfone 4 Selfie Lite ZB553KL',
      'Zenfone V V520KL',
      'Zenfone 4 Selfie ZB553KL',
      'Zenfone 4 ZE554KL',
      'Zenfone 4 Selfie ZD553KL',
      'Zenfone 4 Selfie Pro ZD552KL',
      'Zenfone 4 Pro ZS551KL',
      'Zenfone 4 Max ZC520KL',
      'Zenfone 4 Max Pro ZC554KL',
      'Zenfone 4 Max Plus ZC554KL',
      'Zenfone 4 Max ZC554KL',
      'Zenfone Go ZB552KL',
      'Zenfone Live ZB501KL',
      'Zenfone Pegasus 3s',
      'Zenfone AR ZS571KL',
      'Zenfone 3s Max ZC521TL',
      'Zenfone 3 Zoom ZE553KL',
      'Zenfone 3 Max ZC553KL',
      'Zenfone Go ZB500KL',
      'Zenfone 3 Deluxe 5.5 ZS550KL',
      'Zenfone Go ZB450KL',
      'Zenfone 3 ZE520KL',
      'Zenfone 3 Max ZC520TL',
      'Zenfone 3 Laser ZC551KL',
      'Zenfone Pegasus 3',
      'Zenfone Max ZC550KL (2016)',
      'Zenfone 3 ZE552KL',
      'Zenfone 3 Ultra ZU680KL',
      'Zenfone 3 Deluxe ZS570KL',
      'Zenfone Go ZB551KL',
      'Zenfone Go ZB452KG',
      'Zenfone Go T500',
      'Live G500TG',
      'Zenfone Go ZC451TG',
      'Zenfone 2 Laser ZE551KL',
      'Zenfone 2 Laser ZE600KL',
      'Zenfone Zoom ZX551ML',
      'Zenfone Max ZC550KL',
      'Zenfone Go ZC500TG',
      'Zenfone 2 Laser ZE601KL',
      'Zenfone 2 Laser ZE550KL',
      'Zenfone 2 Laser ZE500KL',
      'Zenfone 2 Laser ZE500KG',
      'Zenfone 2 Deluxe ZE551ML',
      'Zenfone 2E',
      'Pegasus 2 Plus',
      'Zenfone Selfie ZD551KL',
      'Zenfone 2 ZE550ML',
      'Zenfone 2 ZE500CL',
      'Zenfone Zoom ZX550',
      'Zenfone C ZC451CG',
      'Zenfone 5 A501CG (2015)',
      'Zenfone 2 ZE551ML',
      'Pegasus',
      'Zenfone 5 Lite A502CG (2014)',
      'PadFone X mini',
      'PadFone mini 4G (Intel)',
      'Zenfone 5 A500KL (2014)',
      'Zenfone 4 A450CG (2014)',
      'PadFone X',
      'PadFone S',
      'PadFone Infinity Lite',
      'Zenfone 6 A601CG (2014)',
      'Zenfone 6 A600CG (2014)',
      'Zenfone 5 A500CG (2014)',
      'Zenfone 4 (2014)',
      'PadFone mini (Intel)',
      'PadFone E',
      'PadFone mini',
      'PadFone Infinity 2',
      'Fonepad Note FHD6',
      'PadFone Infinity',
      'VivoTab RT TF600T',
      'PadFone 2',
      'PadFone',
      'P835',
      'P565',
      'P552w',
      'P320',
      'M930',
      'P550',
      'P750',
      'P527',
      'M530w',
      'P526',
      'J501',
      'P735',
      'Z810',
      'P535',
      'V66',
      'V80',
      'M310',
      'V75',
      'P525',
      'P505',
      'M307',
      'M303',
    ],
    storages: ['64GB', '128GB', '256GB', '512GB', '1TB'],
  },
  Nokia: {
    popular: ['8910i', '8910', '8890', '8855', '8850'],
    all: [
      '8910i',
      '8910',
      '8890',
      '8855',
      '8850',
      '8810',
      '8800',
      '8310',
      '8250',
      '8210',
      '8110',
      '7600',
      '7280',
      '7270',
      '7260',
      '7250',
      '7210',
      '7200',
      '7110',
      '703',
      '6822',
      '6820',
      '6810',
      '6800',
      '6610i',
      '6610',
      '6510',
      '6500',
      '6310i',
      '6310',
      '6282',
      '6260',
      '6250',
      '6234',
      '6233',
      '6230i',
      '6230',
      '6220',
      '6210',
      '6170',
      '6150',
      '6130',
      '6125',
      '6110',
      '6108',
      '6103',
      '6101',
      '6100',
      '6030',
      '6021',
      '6020',
      '5510',
      '5210',
      '5140i',
      '5140',
      '5110',
      '5100',
      '3610',
      '3530',
      '3510i',
      '3510',
      '3410',
      '3350',
      '3330',
      '3310',
      '3220',
      '3210 (1999)',
      '3200',
      '3128',
      '3120',
      '3110',
      '3108',
      '3100',
      '2650',
      '2600',
      '2300',
      '2110',
      '2100',
      '1100',
      '235 4G (2026)',
      '215 4G (2026)',
      '210 4G',
      '200 4G',
      '123 Shield',
      '110 Power',
      '150 Music',
      '130 Music',
      '110 4G 2nd Edition',
      '105 4G 2nd Edition',
      '110 4G (2024)',
      '108 4G (2024)',
      '105 (2024)',
      '220 4G (2024)',
      '3210',
      '6310 (2024)',
      '5310 (2024)',
      '235 4G (2024)',
      '230 (2024)',
      '225 4G (2024)',
      '215 4G (2024)',
      'C210',
      '150 (2023)',
      '130 (2023)',
      'C300',
      'C110',
      '110 4G (2023)',
      '110 (2023)',
      '106 4G (2023)',
      '106 (2023)',
      '105 4G (2023)',
      '105 (2023)',
      'C02',
      '2780 Flip',
      '110 (2022)',
      '8210 4G',
      '5710 XpressAudio',
      '2660 Flip',
      '105+ (2022)',
      '105 (2022)',
      '2760 Flip',
      'C200',
      'C100',
      '6310 (2021)',
      'C01 Plus',
      '110 4G',
      '105 4G',
      '2720 V Flip',
      '8000 4G',
      '6300 4G',
      '225 4G',
      '215 4G',
      'C3',
      '150 (2020)',
      '125',
      'C2',
      '8.3 5G',
      '5310 (2020)',
      'C1',
      '800 Tough',
      '2720 Flip',
      '110 (2019)',
      '220 4G',
      '105 (2019)',
      '210',
      '106 (2018)',
      '8110 4G',
      '3310 4G',
      '3310 3G',
      '130 (2017)',
      '105 (2017)',
      '3310 (2017)',
      '150',
      '216',
      '230 Dual SIM',
      '230',
      '222 Dual SIM',
      '222',
      '105 Dual SIM (2015)',
      '105 (2015)',
      '215 Dual SIM',
      '215',
      '130 Dual SIM',
      '130',
      '225 Dual SIM',
      '225',
      'X+',
      'Asha 230',
      '220',
      'Asha 503 Dual SIM',
      'Asha 503',
      'Asha 502 Dual SIM',
      'Asha 500 Dual SIM',
      'Asha 500',
      '108 Dual SIM',
      '515',
      '107 Dual SIM',
      '106',
      '208',
      '207',
      'Asha 501',
      'Asha 210',
      'Asha 310',
      '301',
      '105',
      'Asha 205',
      '206',
      '114',
      '109',
      'Asha 309',
      'Asha 308',
      'Asha 311',
      'Asha 306',
      'Asha 305 (2012)',
      '113',
      '112',
      '111',
      '110',
      '103',
      'Asha 302',
      'Asha 203',
      'Asha 202',
      'C5-06',
      'C5-05',
      'C5-04',
      'C2-05',
      'Asha 303',
      'Asha 300',
      'Asha 201',
      'Asha 200',
      'C3-01 Gold Edition',
      '101',
      '100',
      'T7',
      'C2-06',
      'C2-03',
      'C2-02',
      'Oro',
      'C2-01',
      'C5-03',
      'C6-01',
      'C3-01 Touch and Type',
      'C2-00',
      'C1-02',
      'C1-01',
      'C1-00',
      'C3 (2010)',
      '6303i classic',
      '5132 XpressMusic',
      '2710 Navigation Edition',
      '7230',
      '6700 slide',
      '5330 Mobile TV Edition',
      '2690',
      '2220 slide',
      '1800',
      '1616',
      '1280',
      '6788',
      '6350',
      'Mural',
      '3208c',
      '6790 Surge',
      '6760 slide',
      '3720 classic',
      '3710 fold',
      '7020',
      '6730 classic',
      '6600i slide',
      '2730 classic',
      '2720 fold',
      '6216 classic',
      '5330 XpressMusic',
      '5030 XpressRadio',
      '6720 classic',
      '6710 Navigator',
      '6700 classic',
      '2700 classic',
      '8800 Gold Arte',
      '6303 classic',
      '6208c',
      '7100 Supernova',
      '6260 slide',
      '5130 XpressMusic',
      '2330 classic',
      '2323 classic',
      '1662',
      '1661',
      '1202',
      '8800 Carbon Arte',
      '3610 fold',
      '7510 Supernova',
      '7310 Supernova',
      '7210 Supernova',
      '7070 Prism',
      '6600 slide',
      '6600 fold',
      '6212 classic',
      '5220 XpressMusic',
      '5000',
      '3600 slide',
      '2680 slide',
      '1680 classic',
      '6300i',
      '6220 classic',
      '6210 Navigator',
      '3120 classic',
      '7900 Crystal Prism',
      '2600 classic',
      '1209',
      '6263',
      '3110 Evolve',
      '8800 Sapphire Arte',
      '8800 Arte',
      '3555',
      '6301',
      '7900 Prism',
      '6555',
      '5610 XpressMusic',
      '5310 XpressMusic',
      '7500 Prism',
      '6267',
      '3500 classic',
      '8600 Luna',
      '6500 slide',
      '6500 classic',
      '3109 classic',
      '2760',
      '2660',
      '2630',
      '1650',
      '1208',
      '1200',
      '5070',
      'E61i',
      '6131 NFC',
      '3110 classic',
      'N93i',
      '6300',
      '6086',
      '2626',
      '6133',
      '8800 Sirocco',
      '7390',
      '7373',
      '6288',
      '6085',
      '5300',
      '5200',
      '6151',
      '6080',
      '1110i',
      '2610',
      '2310',
      '1112',
      '6136',
      '6131',
      '6126',
      '6070',
      '7380',
      '7370',
      '7360',
      '2652',
      '6280',
      '6270',
      '6111',
      '6060',
      '1600',
      '1110',
      '1101',
      '7250i',
      '3300',
      'X3 Touch and Type S',
      'N92',
      'N91',
      'N90',
      'N87',
      'N80',
      'N71',
      'N70',
      'N-Gage',
      '9500',
      '9300',
      '9210i Communicator',
      '9210 Communicator',
      '9110i Communicator',
      '9000 Communicator',
      '9.3 PureView',
      '8.1 Plus',
      '7710',
      '7700',
      '7650',
      '7.3',
      '6708',
      '6681',
      '6680',
      '6670',
      '6650',
      '6630',
      '6620',
      '6600',
      '3660',
      '3650',
      '3230',
      'G310',
      'G42',
      'XR21',
      'C12 Plus',
      'C12 Pro',
      'G22',
      'C32',
      'C22',
      'C12',
      'X30',
      'G60',
      'G100',
      'C31',
      'G11 Plus',
      'G21',
      'G11',
      'C21 Plus',
      'C21',
      'C2 2nd Edition',
      'G400',
      'X100',
      'G300',
      'G50',
      'XR20',
      'C30',
      'C1 2nd Edition',
      'C20 Plus',
      'X20',
      'X10',
      'G20',
      'G10',
      'G',
      'C20',
      'C10',
      '1.4',
      'C1 Plus',
      '5.4',
      '8 V 5G UW',
      '2 V Tella',
      '3.4',
      '2.4',
      '3 V',
      'C5 Endi',
      'C2 Tennen',
      'C2 Tava',
      '5.3',
      '1.3',
      '2.3',
      '7.2',
      '6.2',
      '3.1 C',
      '3.1 A',
      '2.2',
      'X71',
      '9 PureView',
      '4.2',
      '3.2',
      '1 Plus',
      '8.1 (Nokia X7)',
      '7.1',
      '3.1 Plus',
      '6.1 Plus (Nokia X6)',
      '5.1 Plus (Nokia X5)',
      '5.1',
      '3.1',
      '2.1',
      '8 Sirocco',
      '7 plus',
      '1',
      '6.1',
      '7',
      '2',
      '8',
      '5',
      '3',
      '6',
      'Lumia 638',
      'Lumia 830',
      'Lumia 735',
      'Lumia 730 Dual SIM',
      'Lumia 530 Dual SIM',
      'Lumia 530',
      'X2 Dual SIM',
      'Lumia 930',
      'Lumia 635',
      'Lumia 630 Dual SIM',
      'Lumia 630',
      'XL',
      'X',
      'Lumia Icon',
      'Lumia 525',
      'Lumia 2520',
      'Lumia 1520',
      'Lumia 1320',
      'Lumia 625',
      'Lumia 1020',
      'Lumia 925',
      'Lumia 928',
      'Lumia 720',
      'Lumia 520',
      'Lumia 620',
      'Lumia 505',
      'Lumia 822',
      'Lumia 810',
      'Lumia 510',
      'Lumia 920',
      'Lumia 820',
      'Lumia 610 NFC',
      '800c',
      'Lumia 900',
      'Lumia 610',
      '808 PureView',
      'Lumia 900 AT&T',
      'X2-02',
      'Lumia 710 T-Mobile',
      '801T',
      'X2-05',
      'Lumia 800',
      'Lumia 710',
      '603',
      '701',
      '700',
      '600',
      '500',
      'N950',
      'N9',
      'C5 5MP',
      '702T',
      'X1-01',
      'X7-00',
      'E6',
      'X1-00',
      'C7 Astound',
      'X2-01',
      'E7',
      'C7',
      'X3-02 Touch and Type',
      '5250',
      'X6 8GB (2010)',
      'X5-01',
      'E73 Mode',
      'X5 TD-SCDMA',
      'X2-00',
      'N8',
      'E5',
      'C6',
      'C5 TD-SCDMA',
      'C5',
      'X6 16GB (2010)',
      '5233',
      '5235 Comes With Music',
      'X6 (2009)',
      'X3',
      'N97 mini',
      'N900',
      '5800 Navigation Edition',
      '5230',
      'E72',
      '5530 XpressMusic',
      'E52',
      '5730 XpressMusic',
      'N86 8MP',
      'E75',
      'E55',
      '5630 XpressMusic',
      'N97',
      'E63',
      '5800 XpressMusic',
      'N85',
      'N79',
      'E71',
      'E66',
      '7610 Supernova',
      '5320 XpressMusic',
      '6650 fold',
      '6124 classic',
      'N96',
      'N78',
      'E51 camera-free',
      'N82',
      'E51',
      'N95 8GB',
      'N81 8GB',
      'N81',
      '6121 classic',
      '6120 classic',
      '5700',
      'N77',
      'E90',
      'E65',
      '6110 Navigator',
      'N76',
      '6290',
      'N95',
      'N75',
      'E62',
      'E50',
      '5500 Sport',
      'N93',
      'N73',
      'N72',
      '9300i',
      'E70',
      'E61',
      'E60',
      '3250',
      'N-Gage QD',
      '7610',
    ],
    storages: ['32GB', '64GB', '128GB', '256GB'],
  }
}

export const BRAND_ORDER = [
  'Apple',
  'Samsung',
  'Google',
  'Xiaomi',
  'OnePlus',
  'Huawei',
  'OPPO',
  'vivo',
  'realme',
  'Motorola',
  'Sony',
  'Honor',
  'Nothing',
  'Asus',
  'Nokia',
]

export function listBrands(): string[] {
  return BRAND_ORDER.filter((b) => PHONE_CATALOG[b])
}

export function getBrand(brand: string): BrandCatalog | null {
  return PHONE_CATALOG[brand] || null
}

export type PhoneCatalogSuggestion = {
  brand: string
  model: string
  query: string
}

function normCatalogSearch(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]/g, '')
}

/** Typeahead suggestions from the static phone catalog (brands + models). */
export function searchPhoneCatalogSuggestions(query: string, limit = 6): PhoneCatalogSuggestion[] {
  const q = query.trim().toLowerCase()
  if (q.length < 2) return []

  const words = q.split(/\s+/).filter(Boolean)
  const qNorm = normCatalogSearch(q)
  const scored: { item: PhoneCatalogSuggestion; score: number }[] = []

  for (const brand of listBrands()) {
    const cat = getBrand(brand)
    if (!cat) continue

    const brandLower = brand.toLowerCase()
    const brandNorm = normCatalogSearch(brand)
    if (
      brandLower.startsWith(q) ||
      brandNorm.startsWith(qNorm) ||
      brandLower.includes(q) ||
      words.every((w) => brandLower.includes(w))
    ) {
      scored.push({
        item: { brand, model: '', query: brand },
        score: brandLower.startsWith(q) ? 82 : 58,
      })
    }

    for (const model of cat.all) {
      const line = `${brand} ${model}`.toLowerCase()
      const lineNorm = normCatalogSearch(line)
      const modelLower = model.toLowerCase()
      let score = 0

      if (line === q || lineNorm === qNorm) score = 100
      else if (modelLower.startsWith(q) || lineNorm.startsWith(qNorm)) score = 90
      else if (line.includes(q)) score = 74
      else if (words.every((w) => line.includes(w))) score = 56
      else if (words.some((w) => w.length >= 2 && line.includes(w))) score = 34
      else continue

      if (cat.popular.includes(model)) score += 6
      scored.push({ item: { brand, model, query: `${brand} ${model}`.trim() }, score })
    }
  }

  scored.sort(
    (a, b) =>
      b.score - a.score ||
      a.item.query.localeCompare(b.item.query, undefined, { numeric: true, sensitivity: 'base' }),
  )

  const seen = new Set<string>()
  const out: PhoneCatalogSuggestion[] = []
  for (const { item } of scored) {
    const key = item.query.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    out.push(item)
    if (out.length >= limit) break
  }
  return out
}
